import React, { useState } from "react";
import jsPDF from 'jspdf';
import autoTable from "jspdf-autotable";
// import Header from "../components/Header"; // Header is now in MainReportsDashboard

const GRAY = [211, 211, 211];
const BLUE = [0, 0, 139];
const BLACK = [0, 0, 0];

const formOptions = {
  "Agriculture and Fishery Profile" : [
    "[1] Kalagayang Pang-agrikultura ng Barangay",
    "[2] Uri at Kapasidad ng mga Kagamitang Pangsakahan",
    "[3] Kalagayan ng barangay sa pag-aalaga ng farm animals",
    "[4] Kalagayan ng barangay sa pag-aalaga ng pet animals",
    "[5] Kalagayan ng Barangay sa Pagpaparami ng Isda",
    "[6] Uri at dami ng produktong nipa",
    "[7] Uri at kapasidad ng Fishing vessel",
    "[8] Uri at dami ng mga fishing gear"
  ],
  "Disaster Risk Reduction Profile" : [
    "[1] Preparedness of house during calamity",
    "[2] Preparedness of house materials during calamity",
    "[3] Effects of calamity"
  ],
  "Environmental Sanitation, Health and Nutrition Profile" : [
    "[1] Kalagayang Pangkalinisan",
    "[2] Paraan ng Pagpapalano ng Pamilya",
    "[3] Mga Uri ng mga Sakit",
    "[4] Mga Uri at Bilang ng may Kapansanan",
    "[5] Mga Miyembro ng Pamilya na mayroong Health Insurance",
    "[6] Kalagayang Pangkalusugan: Gulayan, Halamang Gamot, Iodized Salt, pagkain ng 3 beses/araw",
    "[7] Kalagayang Pangnutrisyon, Kalusugan at Pagpapasuso ng Batang 0-6 Taong Gulang",
    // "[8] Kalagayang COVID Vaccination"
  ],
  "Institutional Household, Death, and Migration Profile" : [
    "[1] Kaanyuan ng mga Hindi Residente sa Barangay",
    "[2] Number and Percent Distribution of Non Residents by Age group & Sex",
    "[3] Bilang ng mga tao na umalis at namatay sa barangay"
  ],
  "Socio-economic Profile" : [
    "[1a] Barangay populasyon ayon sa edad at kasarian",
    "[1b] Purok populasyon ayon sa edad at kasarian",
    "[1c] Number and percent distribution of the population by age sex",
    "[1d] Number and percent distribution of the population by age (yearly) sex",
    '[2] Bilang ng rehistradong botante at "Live Births" sa barangay',
    "[3a] Demographic data by barangay (Population, No. of Houses and Families, Religion, Organization, Civil Status, Relation to HH)",
    "[3b] Demographic data by purok (Population, No. of Houses and Families, Religion, Organization, Civil Status, Relation to HH)",
    "[4a] Antas ng pinag-aralan ng barangay",
    "[4b] Antas ng pinag-aralan ng barangay ayon sa kasarian",
    "[5] Uri ng paaralan na pinapasukan ng mga mag-aaral",
    "[6] Out of School Youth",
    "[7] Mga Nagtatrabaho sa Barangay Ayon sa Edad at Kasarian",
    "[8] Uri at Kalagayan ng Hanapbuhay ng Puno ng Pamilya at Asawa",
    "[9] Pinagkakakitaan ng Mamamayan ayon sa Kasarian",
    "[10] Pinagkakakitaan ng Mamamayan ayon sa Uri ng Trabaho",
    "[11a] Bansa, bilang at uri ng hanapbuhay ng mga OFW",
    "[11b] Bansa, bilang at uri ng hanapbuhay ng mga OFW ayon sa kasarian",
    "[12] Kita kada buwan ng bawat pamilya",
    "[13] Kalagayan ng Barangay ayon sa Uri at Kaanyuan ng Bahay",
    "[14] Bilang ng pamilya na mayroong sasakyan, appliances, telepono at internet"
  ],
  "Peace and Order Profile" : [
    "[1] Krimen na naranasan"
  ]
}

function Tables({ searchQuery, isSearchApplied, locationData }) { // Accept props
  // Removed local state for searchQuery and isSearchApplied

  // State for each dropdown's selected value
  const [selectedAgricultureForm, setSelectedAgricultureForm] = useState('');
  const [selectedDisasterForm, setSelectedDisasterForm] = useState('');
  const [selectedEnvironmentalForm, setSelectedEnvironmentalForm] = useState('');
  const [selectedInstitutionalForm, setSelectedInstitutionalForm] = useState('');
  const [selectedSocioEconomicForm, setSelectedSocioEconomicForm] = useState('');
  const [selectedPeaceOrderForm, setSelectedPeaceOrderForm] = useState('');

  function formatDateToDDMMMYY(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = String(date.getFullYear()).slice(-2); // get last two digits
    
    return `${day}-${month}-${year}`;
  }

  const createFormTitle = (doc, title, dateToday, barangayName, municipalName, provinceName, padding) => {
    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text(
      title,
      padding + 10,
      70,
      { align: "left" }
    );

    const formattedDate = formatDateToDDMMMYY(dateToday);
    doc.setFontSize(10);
    doc.setFont(undefined, "italic");
    doc.text(formattedDate, padding + 10., 85, { align: "left" });

    doc.setFont(undefined, "bolditalic");
    doc.text(
      `${
        barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
        municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
        `Province: ${provinceName}`
      }`,
      padding + 15,
      110,
      { align: "left" }
    )
  }

  const createSampleBody = (array, allowLines=true) => {
    const sampleBody = array.flatMap((item, index) => {
      let lineWidth = 6;
      let lineColor = [0, 0, 0];
      if (index === array.length - 1) {
        lineWidth = 3;
      }
      return [
        // Question row
        [
          {
            content: item.question,
            colSpan: 3,
            styles: {
              cellPadding: { left: 20, top: 5, bottom: 5 },
              fontStyle: "bolditalic"
            }
          }
        ],

        // Answer rows
        ...(item.answers.length !== 0 ? item.answers.map(ans => [
          {
            content: ans.answer || ans.content, // handle both key names
            styles: { cellPadding: {left: 30} }
          },
          { content: ans.count },
          { content: ans.percent }
        ]) : []),

        // Summary row
        [
          {
            content: item.summary[0],
            styles: { 
              fontStyle: "bolditalic", 
              cellPadding: {left: 30, top: 10, bottom: 10}, 
              lineWidth: { bottom: allowLines ? lineWidth : 0 }, 
              lineColor: { bottom: lineColor }
          }
          },
          { 
            content: item.summary[1],
            styles: {
              cellPadding: {left: 0, top: 10, bottom: 10},
              lineWidth: { bottom: allowLines ? lineWidth : 0 }, 
              lineColor: { bottom: lineColor }
            }
          },
          { 
            content: item.summary[2],
            styles: {
              cellPadding: {left: 0, top: 10, bottom: 10},
              lineWidth: { bottom: allowLines ? lineWidth : 0 }, 
              lineColor: { bottom: lineColor }
            }
          }
        ]
      ];
    });
    return sampleBody;
  }

  const getCurrentDate = () => {
    const currentDate = new Date();
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const formattedDate = currentDate.toLocaleDateString("en-US", options);
    return formattedDate;
  };

  // handleApplySearch is removed as it's now handled by the parent component
  const generateForm = async (reportType, formName, locationData) => {
    const { regionName, provinceName, municipalName, barangayName } = locationData;
    let doc;
    let fetchedData = {};
    const apiTypeForm = formOptions[reportType].indexOf(formName) + 1;
    const apiTypeReport = Object.keys(formOptions).indexOf(reportType) + 1;
    let baseUrl = `${process.env.REACT_APP_API_URL}/api/locations/api/reports/tables`

    // initialize doc file
    doc = new jsPDF("portrait", "pt", "A4");

    // get doc's dimensions
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const padding = 70;

    if (apiTypeReport && apiTypeForm) {
      // console.log(apiTypeReport, apiTypeForm);
      try {
        const location = `${provinceName}_${municipalName}_${barangayName}`
        const apiUrl = `${baseUrl}?location=${encodeURIComponent(location)}&report=${apiTypeReport}&form=${apiTypeForm}`;
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'x-api-key': process.env.REACT_APP_API_KEY
          }
        });
        const data = await response.json();
        // console.log(data);
        if (Array.isArray(data) && data.length > 0) {
          fetchedData = data; // Assuming it returns an array with one object
          // console.log(fetchedData);
          
        } else {
          console.warn(`API for ${formName} returned an empty array or non-array data. Data received:`, data);
          // Default empty fetchedData if no data
        }
      } catch (error) {
        console.error(`Error fetching data for ${formName}:`, error);
        // Default empty fetchedData on error
      }
    }

    if (reportType === "Agriculture and Fishery Profile") {
      if (formName === "[1] Kalagayang Pang-agrikultura ng Barangay") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table 22. Kalagayang Pang-agrikultura ng Barangay",
          70,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, 70, 85, { align: "left" });

        doc.setFont(undefined, "bolditalic");
        doc.text(`${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, padding + 10, 110, {align: "left"});

        doc.setFont(undefined, "bold");
        doc.text("Bilang ng magsasaka ayon sa pananim at kabuuang lawak ng lupa", padding + 10, 140, {align: "left"});

        const head = [
          [
            "Pananim/Produkto",
            "Bilang ng magsasaka",
            "%",
            "Lawak (Hectares)",
            "Bilang ng Puno",
          ],
        ];

        const parseData = () => {
          const items = [];
          let prev_loc = ''
          for (let item of fetchedData.slice(0, fetchedData.length - 1)) {
            if (item.location !== prev_loc) {
              prev_loc = item.location;
              items.push([
                {
                  content: `Location of Farm: ${item.location}`, 
                  colSpan: 5, styles: {
                    fontStyle: 'bolditalic', 
                    cellPadding: {top: 5},
                    lineWidth: {top: 1},
                    lineColor: BLACK
                  } 
                }
              ])
            }

            items.push([
              {content: item.tanim, styles: {cellPadding: {left: 20}}},
              {content: item.bilang},
              {content: item.percent},
              {content: item.lawak},
              {content: item.tree_count}
            ])
          }
          return items;
        }

        const body = [
          ...parseData(),
          Object.keys(fetchedData).length !== 1 ? [
            {content: "Kabuuan", styles: {fontStyle: "bold"}}, 
            {content: fetchedData[fetchedData.length - 1].bilang, styles: {fontStyle: "bold"}},
            {content: fetchedData[fetchedData.length - 1].percent, styles: {fontStyle: "bold"}},
            {content: fetchedData[fetchedData.length - 1].lawak, styles: {fontStyle: "bold"}},
            {content: fetchedData[fetchedData.length - 1].tree_count, styles: {fontStyle: "bold"}} 
          ] : []
        ]
        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY:155,
          head: head,
          body: body,
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: 5,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, // Increased font size by 2 (from 8 to 10)
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.45, halign: "left" }, // Pananim/Produkto
            1: { cellWidth: contentWidth * 0.15, halign: "right" }, // Bilang ng magsasaka
            2: { cellWidth: contentWidth * 0.13333, halign: "right" }, // %
            3: { cellWidth: contentWidth * 0.13333, halign: "right" }, // Lawak
            4: { cellWidth: contentWidth * 0.13333, halign: "right" }, // Bilang ng Puno
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineWidth = {
                top: 0.5,
                right: 0,
                bottom: 2,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 15,
                left: 8,
              };
            }
          },
        });
      } else if (formName === "[2] Uri at Kapasidad ng mga Kagamitang Pangsakahan") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table 21. Kagamitang Pangsakahan ng mga Pamilya sa Barangay",
          padding + 10,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10., 85, { align: "left" });

        const mainHead = [
            "Uri",
            "Bilang",
            "%"
        ];

        const head = [
          mainHead,
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`}]
        ];

        const body = Object.keys(fetchedData).length !== 1 ? fetchedData.map((item, index) => {
          const lastItem = index === fetchedData.length - 1;
          return [
            {content: item.machinery, styles: {fontStyle: lastItem ? 'bold' : 'normal'}},
            {content: item.bilang, styles: {fontStyle: lastItem ? 'bold' : 'normal'}},
            {content: item.percent, styles: {fontStyle: lastItem ? 'bold' : 'normal'}}
          ] 
        }) : [];

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY:100,
          head: head,
          body: body.length !== 0 ? body : [Array(mainHead.length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: 1,
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.5, halign: "left" }, // Uri
            1: { cellWidth: contentWidth * 0.25, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.25, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = 'bolditalic'
              data.cell.styles.cellPadding = {
                top: 10,
                right: 0,
                bottom: 30,
                left: 8,
              };
            } 
          },
          didDrawPage: function (data) {
            const finalY = data.cursor.y;

            // First line
            doc.setLineWidth(2.5);
            doc.setDrawColor(0, 0, 139); // Blue
            doc.line(padding, finalY + 2, pageWidth - padding, finalY + 2);

            // Second line 
            doc.setLineWidth(2.5);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, finalY + 7, pageWidth - padding, finalY + 7);
          }
        });
      } else if (formName === "[3] Kalagayan ng barangay sa pag-aalaga ng farm animals") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table 24. Kalagayan ng barangay sa pag-aalaga ng farm animals",
          padding + 10,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10., 85, { align: "left" });

        const mainHead = [
            "Kalagayan",
            "Bilang",
            "%"
        ];

        const head = [
          mainHead,
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {halign: "left"}}]
        ];

        const subHeader = [
          {content: "Dami ng pamilyang nag-aalaga ng hayop na pang-kain: ", styles: {fontStyle: "bold"}},
          {content: fetchedData[0][0].family_count, styles: {fontStyle: "bold"}},
          {content: fetchedData[0][0].percent, styles: {fontStyle: "bold"}}
        ];
        const titleHeader = [{content: "Produksyon ng Hayop na pang-kain", colSpan: 3,styles: {fontStyle: "bold"}}]

        const parseData = () => {
          if (Object.keys(fetchedData[1]).length === 0) return [];
          const items = [];
          fetchedData[1].map((item, index) => {
            items.push([
              {content: item.hayop},
              {content: item.bilang},
              {content: item.percent}
            ])
          });
          return items;
        }

        const sampleBody = [
          subHeader,
          titleHeader,
          ...parseData()
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY:100,
          head: head,
          body: sampleBody.length !== 0 ?  sampleBody : [Array(mainHead.length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 10,
              top: 3,
              bottom: 3
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "right" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "right" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = 'bolditalic'
              data.cell.styles.cellPadding = {
                top: 10,
                right: 0,
                bottom: 30,
                left: 10,
              };
            } else if (data.section === "body" && data.row.index === 0) {
              data.cell.styles.cellPadding = {
                left: 10,
                top: 0,
                bottom: 10
              }
            }
          },
          didDrawPage: function (data) {
            const finalY = data.cursor.y;

            // First line
            doc.setLineWidth(2.5);
            doc.setDrawColor(0, 0, 139); // Blue
            doc.line(padding, finalY + 17, pageWidth - padding, finalY + 17);

            // Second line 
            doc.setLineWidth(2.5);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, finalY + 22, pageWidth - padding, finalY + 22);
          }
        });
      } else if (formName === "[4] Kalagayan ng barangay sa pag-aalaga ng pet animals") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table 25. Kalagayan ng barangay sa pag-aalaga ng Hayop",
          padding + 10,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10., 85, { align: "left" });

        const mainHead = [
            "Kalagayan",
            "Bilang",
            "%"
        ];

        const head = [
          mainHead,
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {halign: "left"}}]
        ];

        const subHeader = [
          {content: "Dami ng pamilyang nag-aalaga ng pet animals: ", styles: {fontStyle: "bold"}},
          {content: fetchedData[0][0].family_count, styles: {fontStyle: "bold"}},
          {content: fetchedData[0][0].family_count, styles: {fontStyle: "bold"}}
        ];
        const titleHeader = [{content: "Bilang ng Pet Animals", colSpan: 3,styles: {fontStyle: "bold"}}]

        const parseData = () => {
          if (Object.keys(fetchedData[1]).length === 0) return [];
          const items = [];
          for (let item of fetchedData[1]) {
            items.push([
              {content: item.pet},
              {content: item.bilang},
              {content: item.percent}
            ])
          }
          return items;
        }

        const sampleBody = [
          subHeader,
          titleHeader,
          ...parseData()
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY:100,
          head: head,
          body: sampleBody.length !== 0 ?  sampleBody : [Array(mainHead.length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 10,
              top: 3,
              bottom: 3
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = 'bolditalic'
              data.cell.styles.cellPadding = {
                top: 10,
                right: 0,
                bottom: 30,
                left: 10,
              };
            } else if (data.section === "body" && data.row.index === 0) {
              data.cell.styles.cellPadding = {
                left: 10,
                top: 0,
                bottom: 10
              }
            }
          },
          didDrawPage: function (data) {
            const finalY = data.cursor.y;

            // First line
            doc.setLineWidth(2.5);
            doc.setDrawColor(0, 0, 139); // Blue
            doc.line(padding, finalY + 17, pageWidth - padding, finalY + 17);

            // Second line 
            doc.setLineWidth(2.5);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, finalY + 22, pageWidth - padding, finalY + 22);
          }
        });
      } else if (formName === "[5] Kalagayan ng Barangay sa Pagpaparami ng Isda") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table 20. Fishery Production ng Barangay",
          padding,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        doc.text(`${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, padding + 10, 105, {align: "left"});
        const contentWidth = pageWidth - (padding * 2);

        const mainHead = [[
            {content: "Uri"},
            {content: "Bilang"},
            {content: "%"}
        ]];

        const fish_head = [{content: "Uri ng isda sa palaisdaan", colSpan: 3, styles: {halign: "left", fontStyle: "bold", cellPadding: {top: 20}}}];

        const fish = Object.keys(fetchedData[0]).length != 0 ? fetchedData[0].map((item, index) => (
          [
            {content: item.fish},
            {content: item.bilang},
            {content: item.percent}
          ]
        )) : []

        const fishery_condition_head = [{content: "Uri ng isda sa palaisdaan", colSpan: 3, styles: {halign: "left", fontStyle: "bold", cellPadding: {top: 20}}}];

        const fishery_condition = Object.keys(fetchedData[1]).length != 0 ? fetchedData[1].map((item, index) => (
          [
            {content: item.fishery_condition},
            {content: item.bilang},
            {content: item.percent}
          ]
        )) : []

        const fishery_type_head = [{content: "Uri ng isda sa palaisdaan", colSpan: 3, styles: {halign: "left", fontStyle: "bold", cellPadding: {top: 20}}}];

        const fishery_type = Object.keys(fetchedData[2]).length != 0 ? fetchedData[2].map((item, index) => (
          [
            {content: item.fishery_type},
            {content: item.bilang},
            {content: item.percent}
          ]
        )) : []

        const body = [
          fish_head,
          ...fish,
          fishery_condition_head,
          ...fishery_condition,
          fishery_type_head,
          ...fishery_type
        ]

        autoTable(doc, {
          startY: 120,
          head: mainHead,
          body: body.length !== 0 ?  body : [Array(mainHead.length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 10,
              top: 3,
              bottom: 3
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.4, halign: "left", styles: {cellPadding: {left: 10}} }, // Kalagayan
            1: { cellWidth: contentWidth * 0.3, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.3, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = BLACK;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 0,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 15,
                bottom: 15,
                left: 10,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = 'bolditalic'
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 6,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 3,
                right: 0,
                bottom: 10,
                left: 0,
              };
            }
          }
        });

      } else if (formName === "[6] Uri at dami ng produktong nipa") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table 27. Uri at dami ng produktong mula sa nipa ng mga Pamilya sa Barangay",
          padding,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const mainHead = [
            "Kalagayan",
            "Bilang",
            "Lugar"
        ];

        const head = [
          mainHead,
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {halign: "left"}}]
        ];

        const body = Object.keys(fetchedData).length !== 0 ? fetchedData.map((item, index) => {
          return ([
            {content: item.product_type},
            {content: item.total},
            {content: item.location}
          ])
        }) : [];

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY:100,
          head: head,
          body: body.length !== 0 ?  body : [Array(mainHead.length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 10,
              top: 3,
              bottom: 3
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = 'bolditalic'
              data.cell.styles.cellPadding = {
                top: 10,
                right: 0,
                bottom: 30,
                left: 10,
              };
            }
          }
        });
      } else if (formName === "[7] Uri at kapasidad ng Fishing vessel") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table 28. Fishing vessel na pagmamay-ari ng mga pamilya sa barangay",
          padding,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const mainHead = [
            "Uri",
            "Bilang",
            "Percent"
        ];

        const head = [
          mainHead,
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {halign: "left"}}]
        ];

        const sampleBody = [
          ...fetchedData.slice(0, fetchedData.length - 1).map((item, index) => {
            return (
              [
                {content: item.vessel},
                {content: item.bilang},
                {content: item.percent}
              ]
            )
          }),
          [
            {content: "Kabuuan", styles: {cellPadding: {left: 10, top: 10}, fontStyle: 'bold', lineWidth: {top: 3}, lineColor: GRAY}},
            {content: fetchedData[fetchedData.length - 1].bilang, styles: {cellPadding: {top: 10}, fontStyle: 'bold', lineWidth: {top: 3}, lineColor: GRAY}},
            {content: "100%", styles: {cellPadding: {top: 10}, fontStyle: 'bold', lineWidth: {top: 3}, lineColor: GRAY}},
          ]
        ];

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY:100,
          head: head,
          body: sampleBody.length !== 0 ?  sampleBody : [Array(mainHead.length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 10,
              top: 3,
              bottom: 3
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "right" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          }
        });
      } else if (formName === "[8] Uri at dami ng mga fishing gear") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table 28. Uri at Dami ng Fishing Gears",
          padding,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const mainHead = [
            "Uri",
            "Bilang",
            "Percent"
        ];

        const head = [
          mainHead,
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {halign: "left"}}]
        ];

        const sampleBody = [
          ...fetchedData.slice(0, fetchedData.length - 1).map((item, index) => {
            return (
              [
                {content: item.gear_name},
                {content: item.bilang},
                {content: item.percent}
              ]
            )
          }),
          [
            {content: "Kabuuan", styles: {cellPadding: {left: 10, top: 10}, fontStyle: 'bold', lineWidth: {top: 3}, lineColor: GRAY}},
            {content: fetchedData[fetchedData.length - 1].bilang, styles: {cellPadding: {top: 10}, fontStyle: 'bold', lineWidth: {top: 3}, lineColor: GRAY}},
            {content: "100%", styles: {cellPadding: {top: 10}, fontStyle: 'bold', lineWidth: {top: 3}, lineColor: GRAY}},
          ]
        ];

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY:100,
          head: head,
          body: sampleBody.length !== 0 ?  sampleBody : [Array(mainHead.length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 10,
              top: 3,
              bottom: 3
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "right" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          }
        });
      }
    } else if (reportType === "Disaster Risk Reduction Profile") {
      if (formName === "[1] Preparedness of house during calamity") {
        const title = "Table . Kalagayan ng bahay ayon sa kahandaan sa mga kalamidad.";
        const dateToday = new Date();
        createFormTitle(doc, title, dateToday, barangayName, municipalName, provinceName, padding);

        const head = [
          [
            "Kalagayan",
            "Bilang",
            ""
          ]
        ];

        const bp_data = fetchedData[0].filter(item => item.question === 'bp');
        const hbb_data = fetchedData[0].filter(item => item.question === 'hbb');
        const habd_data = fetchedData[0].filter(item => item.question === 'habd');
        const extension_data = fetchedData[1].filter(item => item.characteristic_type === 'EXTENSION');
        const shape_data = fetchedData[1].filter(item => item.characteristic_type === 'SHAPE');

        const qAndA = [
          {
            question: "Ang bahay ba na kasalukuyan n'yong tinitirhan ay ginawa, idenesenyo o pinangasiwaan ng isang lisensyadong Engineer/Arketikto?",
            answers: bp_data.slice(0, bp_data.length - 1).map((item, index) => {
              return (
                 { content: item.answer, count: item.bilang, percent: `${item.percent}%` }
              )
            }),
            summary: ["Kabuuan", bp_data[bp_data.length - 1].bilang, '']
          },
          {
            question: "Ginawa ba ang bahay na kasalukuyan ninyong tinitirhan bago ang 1990?",
            answers: hbb_data.slice(0, hbb_data.length - 1).map((item, index) => {
              return (
                 { content: item.answer, count: item.bilang, percent: `${item.percent}%` }
              )
            }),
            summary: ["Kabuuan", hbb_data[hbb_data.length - 1].bilang, '']
          },
          {
            question: "Ang bahay ba na kasalukuyan n'yong tinitirhan ay nasira/naapektuhan ng mga nakaraang lindol o ibang kalamidad?",
            answers: habd_data.slice(0, habd_data.length - 1).map((item, index) => {
              return (
                 { content: item.answer, count: item.bilang, percent: `${item.percent}%` }
              )
            }),
            summary: ["Kabuuan", habd_data[habd_data.length - 1].bilang, '']
          },
          {
            question: "Ano ang hugis ng bahay?",
            answers: shape_data.slice(0, shape_data.length - 1).map((item, index) => {
              return (
                 { content: item.answer, count: item.bilang, percent: `${item.percent}%` }
              )
            }),
            summary: ["Kabuuan", shape_data[shape_data.length - 1].bilang, '']
          },
          {
            question: "Ang bahay ba na kasalukuyan n'yong tinitirhan ay sangunyap/pahulog?",
            answers: extension_data.slice(0, extension_data.length - 1).map((item, index) => {
              return (
                 { content: item.answer, count: item.bilang, percent: `${item.percent}%` }
              )
            }),
            summary: ["Kabuuan", extension_data[extension_data.length - 1].bilang, '']
          }
        ];


        const sampleBody = createSampleBody(qAndA);
        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 125,
          head: head,
          body: sampleBody.length !== 0 ?  sampleBody : [Array(head[0].length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = [0, 0, 0];
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 2,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[2] Preparedness of house materials during calamity") {
        const title = "Table . Kalagayan ng materyales ng bahay ayon sa kahandaan sa mga kalamidad";
        const dateToday = new Date();
        createFormTitle(doc, title, dateToday, barangayName, municipalName, provinceName, padding);

        const head = [
          [
            "Kalagayan",
            "Bilang",
            ""
          ]
        ];

        const thicknessData = fetchedData.filter(item => item.characteristic_type === 'THICKNESS');
        const standardData = fetchedData.filter(item => item.characteristic_type === 'STANDARD');
        const supportData = fetchedData.filter(item => item.characteristic_type === 'SUPPORT');
        const materialData = fetchedData.filter(item => item.characteristic_type === 'MATERIAL');
        const foundationData = fetchedData.filter(item => item.characteristic_type === 'FOUNDATION');
        const soilData = fetchedData.filter(item => item.characteristic_type === 'SOIL');
        const conditionData = fetchedData.filter(item => item.characteristic_type === 'CONDITION');

        const qAndA = [
          {
            question: "Ang dingding ba ng inyong bahay na kasalukuyan n'yong tinitirhan ay ginamita ng 6 na pulgada (inches) o 150mm na kapal na hollowblocks?",
            answers: thicknessData.slice(0, thicknessData.length - 1).map((item, index) => {
              return (
                { content: item.answer, count: item.bilang, percent: `${item.percent}%` }
              )
            }),
            summary: ["Kabuuan", thicknessData[thicknessData.length - 1].bilang, ""]
          },
          {
            question: "Ang bakal ba na ginamit sa inyong pader/dingding ay batay sa pamantayan at may tamang agwat?",
            answers: standardData.slice(0, standardData.length - 1).map((item, index) => {
              return (
                { content: item.answer, count: item.bilang, percent: `${item.percent}%` }
              )
            }),
            summary: ["Kabuuan", standardData[standardData.length - 1].bilang, ""]
          },
          {
            question: "Meron bang dingding na walang haligi at biga na higit 3 metro ang pagitan?",
            answers: supportData.slice(0, supportData.length - 1).map((item, index) => {
              return (
                { content: item.answer, count: item.bilang, percent: `${item.percent}%` }
              )
            }),
            summary: ["Kabuuan", supportData[supportData.length - 1].bilang, ""]
          },
          {
            question: "Ano ang kabalyete (gable wall) ng inyong bahay?",
            answers: materialData.slice(0, materialData.length - 1).map((item, index) => {
              return (
                { content: item.answer, count: item.bilang, percent: `${item.percent}%` }
              )
            }),
            summary: ["Kabuuan", materialData[materialData.length - 1].bilang, ""]
          },
          {
            question: "Ano ang pundasyon ng inyong bahay?",
            answers: foundationData.slice(0, foundationData.length - 1).map((item, index) => {
              return (
                { content: item.answer, count: item.bilang, percent: `${item.percent}%` }
              )
            }),
            summary: ["Kabuuan", foundationData[foundationData.length - 1].bilang, ""]
          },
          {
            question: "Ano ang kondisyon ng lupa na tinatayuan ng inyong bahay?",
            answers: soilData.slice(0, soilData.length - 1).map((item, index) => {
              return (
                { content: item.answer, count: item.bilang, percent: `${item.percent}%` }
              )
            }),
            summary: ["Kabuuan", soilData[soilData.length - 1].bilang, ""]
          },
          {
            question: "Ano ang kabuuang kalagayan ng inyong bahay?",
            answers: conditionData.slice(0, conditionData.length - 1).map((item, index) => {
              return (
                { content: item.answer, count: item.bilang, percent: `${item.percent}%` }
              )
            }),
            summary: ["Kabuuan", conditionData[conditionData.length - 1].bilang, ""]
          }
        ];


        const sampleBody = createSampleBody(qAndA);
        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 125,
          head: head,
          body: sampleBody.length !== 0 ?  sampleBody : [Array(head[0].length).fill("")],
          theme: "grid",
          showHead: 'firstPage',
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 3,
              bottom: 3
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = [0, 0, 0];
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 2,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[3] Effects of calamity") {
        const title = "Table . Kalagayan ng pamilya ayon sa karansan sa kalamidad";
        const dateToday = new Date();
        createFormTitle(doc, title, dateToday, barangayName, municipalName, provinceName, padding);

        const head = [
          [
            "Kalagayan",
            "Bilang",
            ""
          ]
        ];

        const data = {
          ed: fetchedData.filter(item => item.characteristic_type === 'ED'), 
          dt: fetchedData.filter(item => item.characteristic_type === 'DT'),
          eayn: fetchedData.filter(item => item.characteristic_type === 'EAYN'),
          ea: fetchedData.filter(item => item.characteristic_type === 'EA'),
          di: fetchedData.filter(item => item.characteristic_type === 'DI'),
          asmw: fetchedData.filter(item => item.characteristic_type === 'ASMW'),
          as: fetchedData.filter(item => item.characteristic_type === 'AS')
        }

        const qAndA = [
          {
            question: "Nakaranas ba kayo ng kalamidad sa nakalipas o nakaraang taon?",
            answers: data.ed.length === 1 ? [] : data.ed.filter(item => item.opt !== 'Total').map(item => ({
              content: item.opt,
              count: item.bilang,
              percent: item.percent
            })),
            summary: data.ed.length === 1 ? ['Kabuuan', 0, 0] : data.ed.filter(item => item.opt === 'Total').flatMap(item => ['Kabuuan', item.bilang, item.percent])
          },
          {
            question: "Mga uri ng kalamidad na naranasan ng pamilya?",
            answers: data.dt.length === 0 ? [] : data.dt.filter(item => item.opt !== 'Total').map(item => ({
              content: item.opt,
              count: item.bilang,
              percent: item.percent
            })),
            summary: data.dt.length === 0 ? ['Kabuuan', 0, 0] : data.dt.filter(item => item.opt === 'Total').flatMap(item => ['Kabuuan', item.bilang, item.percent])
          },
          {
            question: "Bilang ng mga nag-evacuate sa panahon na kalamidad",
            answers: data.eayn.length === 0 ? [] : data.eayn.filter(item => item.opt !== 'Total').map(item => ({
              content: item.opt,
              count: item.bilang,
              percent: item.percent
            })),
            summary: data.eayn.length === 0 ? ['Kabuuan', 0, 0] : data.eayn.filter(item => item.opt === 'Total').flatMap(item => ['Kabuuan', item.bilang, item.percent])
          },
          {
            question: "Mga lugar kung saan pumunta para mag evacuate",
            answers: data.ea.length === 0 ? [] : data.ea.filter(item => item.opt !== 'Total').map(item => ({
              content: item.opt,
              count: item.bilang,
              percent: item.percent
            })),
            summary: data.ea.length === 0 ? ['Kabuuan', 0, 0] : data.ea.filter(item => item.opt === 'Total').flatMap(item => ['Kabuuan', item.bilang, item.percent])
          },
          {
            question: "Epekto o damage ng naransang kalamidad",
            answers: data.di.length === 0 ? [] : data.di.filter(item => item.opt !== 'Total').map(item => ({
              content: item.opt,
              count: item.bilang,
              percent: item.percent
            })),
            summary: data.di.length === 0 ? ['Kabuuan', 0, 0] : data.di.filter(item => item.opt === 'Total').flatMap(item => ['Kabuuan', item.bilang, item.percent])
          },
          {
            question: "Bilang ng pamilya na natulungan sa panahon ng kalamidad",
            answers: data.asmw.length === 1 ? [] : data.asmw.filter(item => item.opt !== 'Total').map(item => ({
              content: item.opt,
              count: item.bilang,
              percent: item.percent
            })),
            summary: data.asmw.length === 1 ? ['Kabuuan', 0, 0] : data.asmw.filter(item => item.opt === 'Total').flatMap(item => ['Kabuuan', item.bilang, item.percent])
          },
          {
            question: "Mga tulong na natanggap ayon sa tumulong sa panahon ng kalamidad",
            answers: data.as.length === 0 ? [] : data.as.filter(item => item.opt !== 'Total').map(item => ({
              content: item.opt,
              count: item.bilang,
              percent: item.percent
            })),
            summary: data.as.length === 0 ? ['Kabuuan', 0, 0] :  data.as.filter(item => item.opt === 'Total').flatMap(item => ['Kabuuan', item.bilang, item.percent])
          }
        ];


        const sampleBody = createSampleBody(qAndA);
        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 125,
          head: head,
          body: sampleBody.length !== 0 ?  sampleBody : [Array(head[0].length).fill("")],
          theme: "grid",
          showHead: 'firstPage',
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 3,
              bottom: 3
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = [0, 0, 0];
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 2,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } 
    } else if (reportType === "Environmental Sanitation, Health and Nutrition Profile") {
      if (formName === "[1] Kalagayang Pangkalinisan") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table 15. Kalagayang Pangkalusugan ng Pamilya",
          padding + 10,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10, 85, { align: "left" });

        const mainHead = [
            "Kalagayan",
            "Bilang",
            "%"
        ];

        const head = [
          mainHead,
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {halign: "left"}}]
        ];

        const fetchedToiletData = () => {
          if (Object.keys(fetchedData[0]).length === 0) return [];
          const items = [];
          let prev_category = ''
          let status = [];
          for (let item of fetchedData[0].slice(0, fetchedData[0].length-1)) {
            if (prev_category === '') {
              prev_category = item.category;
              status.push({
                name: item.palikuran,
                count: item.bilang,
                percent: item.percent
              })
            } else if (item.category === prev_category) {
              status.push({
                name: item.palikuran,
                count: item.bilang,
                percent: item.percent
              })
            } else {
              items.push({
                category: prev_category,
                status: status
              });
              prev_category = item.category
              status = [
                {
                  name: item.palikuran,
                  count: item.bilang,
                  percent: item.percent
                }
              ]
            }
          }
          items.push({
            category: prev_category,
            status: status
          });
          return items;
        }

        const toiletData = 
          {title: "Uri ng Palikuran:", categories: fetchedToiletData(),
          summary: {name: "Kabuuan", count: fetchedData[0][fetchedData[0].length - 1].bilang, percent: 100.00}
          }
        
        const fetchedGarbageData = () => {
          if (Object.keys(fetchedData[1]).length === 0) return [];
          const items = [];
          for (let item of fetchedData[1].slice(0, fetchedData[1].length - 1)) {
            items.push(
              {type: item.method,
              count: item.bilang,
              percent: item.percent}
            )
          }

          return items;
        }
        
        const garbageDisposalData = {
          title: "Paraan ng Pagtatapon ng Basura", types: fetchedGarbageData(),
          summary: {name: 'Kabuuan', count: fetchedData[1][fetchedData[1].length - 1].bilang, percent: 100.00}
        }
        

        const body1 = [
          // Toilet Body
          [{content: toiletData.title, colSpan: 3, styles: {fontStyle: "bold"}}],
          ...toiletData.categories.flatMap((item, index) => {
            const rows = [];

            rows.push([
              {content: item.category, colSpan: 3, styles: {fontStyle: "bold", cellPadding: {left: 20, top: 10, bottom: 10}}}
            ])

            item.status.forEach((statusItem, index) => {
              rows.push([
                {content: statusItem.name, styles: {cellPadding: {left: 30}}},
                {content: statusItem.count},
                {content: statusItem.percent}
              ])
            })

            return rows;
          }),
          [
            {content: toiletData.summary.name, styles: {fontStyle: "bolditalic", cellPadding: {left: 30}}},
            {content: toiletData.summary.count, styles: {fontStyle: "bold"}},
            {content: toiletData.summary.percent, styles: {fontStyle: "bold"}}
          ],

          // Garbage Dispossal Body
          [{content: garbageDisposalData.title, colSpan: 3, styles: {fontStyle: "bold"}}],
          ...garbageDisposalData.types.flatMap((item, index) => {
            const rows = [];

            rows.push([
              {content: item.type, styles: {cellPadding: {left: 30}}},
              {content: item.count},
              {content: item.percent}

            ])

            return rows;
          }),
          [
            {content: garbageDisposalData.summary.name, styles: {fontStyle: "bolditalic", cellPadding: {left: 30}}},
            {content: garbageDisposalData.summary.count, styles: {fontStyle: "bold"}},
            {content: garbageDisposalData.summary.percent, styles: {fontStyle: "bold"}}
          ],
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY:100,
          head: head,
          body: body1.length !== 0 ?  body1 : [Array(mainHead.length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 10,
              top: 3,
              bottom: 3
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = 'bolditalic'
              data.cell.styles.cellPadding = {
                top: 10,
                right: 0,
                bottom: 15,
                left: 0,
              };
            }
          },
          didDrawPage: function (data) {
            const finalY = data.cursor.y;

            // First line
            doc.setLineWidth(2.5);
            doc.setDrawColor(0, 0, 139); // Blue
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });

        doc.addPage();

        const generalWater = fetchedData[2].filter(item => item.used_for === 'General');
        const cookingWater = fetchedData[2].filter(item => item.used_for === 'Drinking/Cooking');
        

        const fetchedGeneralUsage = () => {
          if (Object.keys(generalWater).length === 0) return [];
          const items = [];
          let prev_category = ''
          let sources = [];
          for (let item of generalWater.slice(0, generalWater.length-1)) {
            if (prev_category === '') {
              prev_category = item.category;
              sources.push({
                name: item.source_type,
                count: item.bilang,
                percent: item.percent
              })
            } else if (item.category === prev_category) {
              sources.push({
                name: item.source_type,
                count: item.bilang,
                percent: item.percent
              })
            } else {
              items.push({
                category: prev_category,
                sources: sources
              });
              prev_category = item.category
              sources = [
                {
                  name: item.source_type,
                  count: item.bilang,
                  percent: item.percent
                }
              ]
            }
          }
          items.push({
            category: prev_category,
            sources: sources
          });
          return items;
        }

        const fetchedCookingUsage = () => {
          if (Object.keys(cookingWater).length === 0) return [];
          const items = [];
          let prev_category = ''
          let sources = [];
          for (let item of cookingWater.slice(0, cookingWater.length-1)) {
            if (prev_category === '') {
              prev_category = item.category;
              sources.push({
                name: item.source_type,
                count: item.bilang,
                percent: item.percent
              })
            } else if (item.category === prev_category) {
              sources.push({
                name: item.source_type,
                count: item.bilang,
                percent: item.percent
              })
            } else {
              items.push({
                category: prev_category,
                sources: sources
              });
              prev_category = item.category
              sources = [
                {
                  name: item.source_type,
                  count: item.bilang,
                  percent: item.percent
                }
              ]
            }
          }
          items.push({
            category: prev_category,
            sources: sources
          });
          return items;
        }

        const generalUsageData = {
          title: "Pinagkukunan ng Tubig - washing and general use", types: fetchedGeneralUsage(),
          summary: {name: 'Kabuuan', count: generalWater[generalWater.length - 1].bilang, percent: 100.00}
        }

        const cookingUsageData = {
          title: "Pinagkukunan ng Tubig - drinking and cooking", types: fetchedCookingUsage(),
          summary: {name: 'Kabuuan', count: cookingWater[cookingWater.length - 1].bilang, percent: 100.00}
        }

        const body2 = [
          [{content: generalUsageData.title, colSpan: 3, styles: {fontStyle: "bold"}}],
          ...generalUsageData.types.flatMap((item, index) => {
            const rows = [];

            rows.push([
              {content: item.category, colSpan: 3, styles: {fontStyle: "bold", cellPadding: {left: 20, top: 10, bottom: 10}}}
            ])

            item.sources.forEach((sourceItem, index) => {
              rows.push([
                {content: sourceItem.name, styles: {cellPadding: {left: 30}}},
                {content: sourceItem.count},
                {content: sourceItem.percent}
              ])
            })

            return rows;
          }),
          [
            {content: generalUsageData.summary.name, styles: {fontStyle: "bolditalic", cellPadding: {left: 30}}},
            {content: generalUsageData.summary.count, styles: {fontStyle: "bold"}},
            {content: generalUsageData.summary.percent, styles: {fontStyle: "bold"}}
          ],
          [{
            content: 'Source of level: (http://nap.psa.gov.ph/glossary/terms/, retrieved May 2, 2018).', 
            colSpan: 3,
            styles: {fontStyle: "bolditalic", cellPadding: {top: 10, bottom: 20, left: 20}}
          }],
          [{content: cookingUsageData.title, colSpan: 3, styles: {fontStyle: "bold"}}],
          ...cookingUsageData.types.flatMap((item, index) => {
            const rows = [];

            rows.push([
              {content: item.category, colSpan: 3, styles: {fontStyle: "bold", cellPadding: {left: 20, top: 10, bottom: 10}}}
            ])

            item.sources.forEach((sourceItem, index) => {
              rows.push([
                {content: sourceItem.name, styles: {cellPadding: {left: 30}}},
                {content: sourceItem.count},
                {content: sourceItem.percent}
              ])
            })

            return rows;
          }),
          [
            {content: cookingUsageData.summary.name, styles: {fontStyle: "bolditalic", cellPadding: {left: 30}}},
            {content: cookingUsageData.summary.count, styles: {fontStyle: "bold"}},
            {content: cookingUsageData.summary.percent, styles: {fontStyle: "bold"}}
          ],
          [{
            content: 'Source of level: (http://nap.psa.gov.ph/glossary/terms/, retrieved May 2, 2018).', 
            colSpan: 3,
            styles: {fontStyle: "bolditalic", cellPadding: {top: 10, bottom: 20, left: 20}}
          }]
        ];

        autoTable(doc, {
          startY: padding,
          head: head,
          body: body2.length !== 0 ?  body2 : [Array(mainHead.length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 10,
              top: 3,
              bottom: 3
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = 'bolditalic'
              data.cell.styles.cellPadding = {
                top: 10,
                right: 0,
                bottom: 15,
                left: 0,
              };
            }
          },
          didDrawPage: function (data) {
            const finalY = data.cursor.y;

            // First line
            doc.setLineWidth(2.5);
            doc.setDrawColor(0, 0, 139); // Blue
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });

        doc.addPage();

        const body3 = [
          [{content: "Source of water is located within premise", styles: {fontStyle: "bolditalic", cellPadding: {left: 10}}}],
          [
            {content: "Yes", styles: {cellPadding: {left: 50}}},
            {content: fetchedData[3][0].within_premise, styles: {fontStyle: 'bold'}},
            {content: fetchedData[3][0].within_premise_percent, styles: {fontStyle: 'bold'}},
          ],
          [
            {content: "No", styles: {cellPadding: {left: 50}}},
            {content: fetchedData[3][0].not_within_premise, styles: {fontStyle: 'bold'}},
            {content: fetchedData[3][0].not_within_premise_percent, styles: {fontStyle: 'bold'}},
          ],
          [
            {content: "Kabuuan", styles: {fontStyle: "bolditalic", cellPadding: {left: 25}}},
            {content: fetchedData[3][0].total, styles: {fontStyle: 'bold'}},
            {content: 100.00, styles: {fontStyle: 'bold'}},
          ],
          [{content: "Source of water is available at least 12hrs/day", styles: {fontStyle: "bolditalic", cellPadding: {left: 10}}}],
          [
            {content: "Yes", styles: {cellPadding: {left: 50}}},
            {content: fetchedData[3][0].available, styles: {fontStyle: 'bold'}},
            {content: fetchedData[3][0].available_percent, styles: {fontStyle: 'bold'}},
          ],
          [
            {content: "No", styles: {cellPadding: {left: 50}}},
            {content: fetchedData[3][0].not_available, styles: {fontStyle: 'bold'}},
            {content: fetchedData[3][0].not_available_percent, styles: {fontStyle: 'bold'}},
          ],
          [
            {content: "Kabuuan", styles: {fontStyle: "bolditalic", cellPadding: {left: 25}}},
            {content: fetchedData[3][0].total, styles: {fontStyle: 'bold'}},
            {content: 100.00, styles: {fontStyle: 'bold'}},
          ]
        ]
        
        autoTable(doc, {
          startY: padding,
          head: head,
          body: body3.length !== 0 ?  body3 : [Array(mainHead.length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 10,
              top: 3,
              bottom: 3
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = 'bolditalic'
              data.cell.styles.cellPadding = {
                top: 10,
                right: 0,
                bottom: 15,
                left: 0,
              };
            }
          },
          didDrawPage: function (data) {
            const finalY = data.cursor.y;

            // First line
            doc.setLineWidth(2.5);
            doc.setDrawColor(0, 0, 139); // Blue
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });


      } else if (formName === "[2] Paraan ng Pagpapalano ng Pamilya") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table 15. Kalagayang Pangkalusugan ng Pamilya",
          padding + 10,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10, 85, { align: "left" });

        const mainHead = [
            "Kalagayan",
            "Bilang",
            "%"
        ];

        const head = [
          mainHead,
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {halign: "left"}}]
        ];
        

        const kabuuangGumagamit = fetchedData[0].filter(item => item.name === 'Gumagamit')[0];
        const kabuuangHindiGumagamit = fetchedData[0].filter(item => item.name === 'Hindi Gumagamit')[0];
        const kabuuangHindiNaaayon = fetchedData[0].filter(item => item.name === 'Hindi Naaayon')[0];
        const kabuuangPamilya = fetchedData[0].filter(item => item.name === 'Total Families')[0];
        
        

        const sampleBody = [
          [{ content: "Paraan ng pagpaplano ng pamilya", colSpan: 3, styles: { fontStyle: "bold" } }],
          [
            { content: "Gumagamit:", styles: { fontStyle: "bolditalic", cellPadding: { left: 10 } } }, 
            { content: kabuuangGumagamit.bilang, styles: { fontStyle: "bolditalic" } }, 
            { content: kabuuangGumagamit.percent, styles: { fontStyle: "bolditalic" } }
          ],
          ...fetchedData[0].slice(1, 13).map((item, index) => {
            return (
              [
                { content: item.name, styles: { cellPadding: { left: 20 } } }, 
                { content: item.bilang }, 
                { content: `${item.percent}%` }
              ]
            )
          }),
          [
            { content: "Hindi Gumagamit: ", styles: { fontStyle: "bolditalic", cellPadding: { left: 10 } } }, 
            { content: kabuuangHindiGumagamit.bilang, styles: { fontStyle: "bolditalic" } }, 
            { content: `${kabuuangHindiGumagamit.percent}`, styles: { fontStyle: "bolditalic" } }
          ],
          [
            { content: "Hindi Naaayon: ", styles: { fontStyle: "bolditalic", cellPadding: { left: 10 } } }, 
            { content: kabuuangHindiNaaayon.bilang, styles: { fontStyle: "bolditalic" } }, 
            { content: `${kabuuangHindiNaaayon.percent}`, styles: { fontStyle: "bolditalic" } }
          ],
          [
            { content: "Kabuuang Pamilya", styles: { fontStyle: "bolditalic", cellPadding: { left: 10, top: 5, bottom: 10 } } }, 
            { content: kabuuangPamilya.bilang, styles: { fontStyle: "bolditalic" } }, 
            { content: "100.00", styles: { fontStyle: "bolditalic" } }
          ],
          [
            { content: "Bilang ng mga Buntis: ", styles: { fontStyle: "bold", cellPadding: { top: 10 } } }, 
            { content: fetchedData[1][0].bilang, styles: { fontStyle: "bold" } }
          ]
        ];


        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY:100,
          head: head,
          body: sampleBody.length !== 0 ?  sampleBody : [Array(mainHead.length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 10,
              top: 3,
              bottom: 3
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = 'bolditalic'
              data.cell.styles.cellPadding = {
                top: 10,
                right: 0,
                bottom: 15,
                left: 0,
              };
            } else if (data.section === "body" && data.row.index === 0) {
              data.cell.styles.cellPadding = {
                left: 0,
                top: 0,
                bottom: 10
              }
            }
          },
          didDrawPage: function (data) {
            const finalY = data.cursor.y;

            // First line
            doc.setLineWidth(2.5);
            doc.setDrawColor(0, 0, 139); // Blue
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);

            // Second line 
            doc.setLineWidth(2.5);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, finalY + 20, pageWidth - padding, finalY + 20);
          }
        });
      } else if (formName === "[3] Mga Uri ng mga Sakit") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table 16. Kalagayang Pangkalusugan ng Barangay - Uri ng Mga Sakit",
          padding,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const mainHead = [
            "Kalagayan",
            "Bilang",
            "%"
        ];

        const head = [
          mainHead,
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {halign: "left"}}]
        ];

        const maleAndFemaleData = fetchedData.filter(item => item.sex ==='Both sex').map((item, index) => {
          return ({sakit: item.sakit, bilang: item.bilang, percent: item.percent})
        });

        const maleAndFemale = () => maleAndFemaleData.map((item, index) => {
          if (index === maleAndFemaleData.length - 1) {
            return [{content: "TOTAL", styles: {fontStyle: "bold", fontSize: 10, cellPadding: {left: 35, top: 10, bottom: 10}, lineWidth: {bottom: 6}, lineColor: GRAY}}, 
            {content: item.bilang, styles: {fontStyle: "bold", fontSize: 10, cellPadding: {top: 10, bottom: 10}, lineWidth: {bottom: 6}, lineColor: GRAY}},
            {content: "", styles: {fontStyle: "bold", fontSize: 10, cellPadding: {top: 10, bottom: 10}, lineWidth: {bottom: 6}, lineColor: GRAY}},   
            ]
          }
          return [
            {content: item.sakit, styles: {cellPadding: {left: 35}}},
            {content: item.bilang},
            {content: item.percent}
          ]
          }
        );

        const femaleData = fetchedData.filter(item => item.sex === 'Female').map((item, index) => {
          return ({sakit: item.sakit, bilang: item.bilang, percent: item.percent})
        });

        const female = () => femaleData.map((item, index) => {
          if (index === femaleData.length - 1) {
            return (
              [
                {content: "Sub-total", styles: {fontStyle: "bold", fontSize: 10, cellPadding: {left: 35, top: 10, bottom: 10}}},
                {content: item.bilang, styles: {fontStyle: "bold", fontSize: 10, cellPadding: {top: 10, bottom: 10}}}
              ]
            )
          }
          return [
            {content: item.sakit, styles: {cellPadding: {left: 35}}},
            {content: item.bilang},
            {content: item.percent}
          ]}
        );

        const maleData = fetchedData.filter(item => item.sex === 'Male').map((item, index) => {
          return ({sakit: item.sakit, bilang: item.bilang, percent: item.percent})
        });

        const male = () => maleData.map((item, index) => {
          if (index === maleData.length - 1) {
            return [
              {content: "Sub-total", styles: {fontStyle: "bold", fontSize: 10, cellPadding: {left: 35, top: 10, bottom: 10}}},
              {content: item.bilang, styles: {fontStyle: "bold", fontSize: 10, cellPadding: {top: 10, bottom: 10}}}
            ]
          }

          return [
            {content: item.sakit, styles: {cellPadding: {left: 35}}},
            {content: item.bilang},
            {content: item.percent}
          ]
        } 
          
        );

        const sampleBody = [
          // male and female sickness
          [{content: "Both Male and Female", colSpan: 3, styles: {fontStyle: "bolditalic", fontSize: 12, cellPadding: {left: 25, top: 5, bottom: 10}}}],
          ...maleAndFemale(),
          
          // female sickness
          [{content: "Female", colSpan: 3, styles: {fontStyle: "bolditalic", fontSize: 12, cellPadding: {left: 25, top: 5, bottom: 10}}}],
          ...female(),
          
          // male sickeness
          [{content: "Male", colSpan: 3, styles: {fontStyle: "bolditalic", fontSize: 12, cellPadding: {left: 25, top: 5, bottom: 10}}}],
          ...male(),
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY:100,
          head: head,
          body: sampleBody.length !== 0 ?  sampleBody : [Array(mainHead.length).fill("")],
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 1.5,
              bottom: 1.5
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = 'bolditalic'
              data.cell.styles.cellPadding = {
                top: 10,
                right: 0,
                bottom: 15,
                left: 10,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(2.5);
            doc.setDrawColor(0, 0, 139); // Blue
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[4] Mga Uri at Bilang ng may Kapansanan") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table 17. Kalagayang Pangkalusugan ng Barangay - Mga Kapansanan",
          padding,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const mainHead = [
            "Kalagayan",
            "Bilang",
            "%"
        ];

        const head = [
          mainHead,
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {halign: "left"}}]
        ];

        const maleAndFemaleData = fetchedData.filter(item => item.sex ==='Both sex').map((item, index) => {
          return ({sakit: item.kapansanan, bilang: item.bilang, percent: item.percent})
        });

        const maleAndFemale = () => maleAndFemaleData.map((item, index) => {
          if (index === maleAndFemaleData.length - 1) {
            return [
              {content: "TOTAL", styles: {fontStyle: "bold", fontSize: 10, cellPadding: {left: 35, top: 10, bottom: 10}, lineWidth: {bottom: 6}, lineColor: GRAY}}, 
              {content: item.bilang, styles: {fontStyle: "bold", fontSize: 10, cellPadding: {top: 10, bottom: 10}, lineWidth: {bottom: 6}, lineColor: GRAY}},
              {content: "", styles: {fontStyle: "bold", fontSize: 10, cellPadding: {top: 10, bottom: 10}, lineWidth: {bottom: 6}, lineColor: GRAY}},          
            ]
          }
          return [
            {content: item.sakit, styles: {cellPadding: {left: 35}}},
            {content: item.bilang},
            {content: item.percent}
          ]
        });

        const femaleData = fetchedData.filter(item => item.sex ==='Female').map((item, index) => {
          return ({sakit: item.kapansanan, bilang: item.bilang, percent: item.percent})
        });

        const female = () => femaleData.map((item, index) => {
          if (index === femaleData.length - 1) {
            return [
              {content: "Sub-total", styles: {fontStyle: "bold", fontSize: 10, cellPadding: {left: 35, top: 10, bottom: 10}}},
              {content: item.bilang, styles: {fontStyle: "bold", fontSize: 10, cellPadding: {top: 10, bottom: 10}}}
            ]
          }
          return [
            {content: item.sakit, styles: {cellPadding: {left: 35}}},
            {content: item.bilang},
            {content: item.percent}
          ]
        });

        const maleData = fetchedData.filter(item => item.sex ==='Male').map((item, index) => {
          return ({sakit: item.kapansanan, bilang: item.bilang, percent: item.percent})
        });

        const male = () => maleData.map((item, index) => {
          if (index === maleData.length - 1) {
            return [
              {content: "Sub-total", styles: {fontStyle: "bold", fontSize: 10, cellPadding: {left: 35, top: 10, bottom: 10}}},
              {content: item.bilang, styles: {fontStyle: "bold", fontSize: 10, cellPadding: {top: 10, bottom: 10}}}
            ]
          }
          return [
            {content: item.sakit, styles: {cellPadding: {left: 35}}},
            {content: item.bilang},
            {content: item.percent}
          ]
        });

        const sampleBody = [
          // male and female disability
          [{content: "Both Male and Female", colSpan: 3, styles: {fontStyle: "bolditalic", fontSize: 12, cellPadding: {left: 25, top: 5, bottom: 10}}}],
          ...maleAndFemale(),
          
          // female disability
          [{content: "Female", colSpan: 3, styles: {fontStyle: "bolditalic", fontSize: 12, cellPadding: {left: 25, top: 5, bottom: 10}}}],
          ...female(),
          
          // male disability
          [{content: "Male", colSpan: 3, styles: {fontStyle: "bolditalic", fontSize: 12, cellPadding: {left: 25, top: 5, bottom: 10}}}],
          ...male(),
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY:100,
          head: head,
          body: sampleBody.length !== 0 ?  sampleBody : [Array(mainHead.length).fill("")],
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 1.5,
              bottom: 1.5
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = 'bolditalic'
              data.cell.styles.cellPadding = {
                top: 10,
                right: 0,
                bottom: 15,
                left: 10,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(2.5);
            doc.setDrawColor(0, 0, 139); // Blue
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[5] Mga Miyembro ng Pamilya na mayroong Health Insurance") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table 13. Bilang ng mayroong Health Insurance",
          padding + 10,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10, 85, { align: "left" });

        const mainHead = [
            "Uri",
            "Bilang",
            "%"
        ];

        const head = [
          mainHead,
          [{content: `Barangay: ${barangayName}, ${municipalName}, ${provinceName}`, styles: {halign: "left"}}]
        ];

        const maleAndFemaleData = fetchedData.filter(item => item.sex ==='Both sex').map((item, index) => {
          return ({insurance: item.insurance, bilang: item.bilang, percent: item.percent})
        });

        let totalEntries = 0;
        let maleTotal = 0;
        let femaleTotal = 0;

        const maleAndFemale = () => maleAndFemaleData.map((item, index) => {
          if (index === maleAndFemaleData.length - 1) {
            totalEntries = item.bilang;
            return [
              {content: "Total", styles: {fontStyle: "bold", fontSize: 10, cellPadding: {left: 35, top: 10, bottom: 10}, lineWidth: {bottom: 6}, lineColor: GRAY}}, 
              {content: item.bilang, styles: {fontStyle: "bold", fontSize: 10, cellPadding: {top: 10, bottom: 10}, lineWidth: {bottom: 6}, lineColor: GRAY}},
              {content: "", styles: {fontStyle: "bold", fontSize: 10, cellPadding: {top: 10, bottom: 10}, lineWidth: {bottom: 6}, lineColor: GRAY}},          
            ]
          }
          return [
            {content: item.insurance, styles: {cellPadding: {left: 35}}},
            {content: item.bilang},
            {content: item.percent}
          ]
        }
        );

        const femaleData = fetchedData.filter(item => item.sex ==='Female').map((item, index) => {
          return ({insurance: item.insurance, bilang: item.bilang, percent: item.percent})
        });

        const female = () => femaleData.map((item, index) => {
          if (index === femaleData.length - 1) {
            return [
              {content: "Female", styles: {fontStyle: "bold", fontSize: 12, cellPadding: {left: 30, top: 5, bottom: 5}, fillColor: GRAY}},
              {content: item.bilang, styles: {fontStyle: "bold", fontSize: 12, cellPadding: {top: 5, bottom: 5}, fillColor: GRAY}},
              {content: "", styles: {cellPadding: {top: 5, bottom: 5}, fillColor: GRAY}}
            ]
          }
          return [
            {content: item.insurance, styles: {cellPadding: {left: 35}}},
            {content: item.bilang},
            {content: item.percent}
          ]
        });

        const maleData = fetchedData.filter(item => item.sex ==='Male').map((item, index) => {
          return ({insurance: item.insurance, bilang: item.bilang, percent: item.percent})
        });

        const male = () => maleData.map((item, index) => {
          if (index === maleData.length - 1) {
            return [
              {content: "Male", styles: {fontStyle: "bold", fontSize: 12, cellPadding: {left: 30, top: 5, bottom: 5}, fillColor: GRAY}},
              {content: item.bilang, styles: {fontStyle: "bold", fontSize: 12, cellPadding: {left: 0, top: 5, bottom: 5}, fillColor: GRAY}},
              {content: "", styles: {cellPadding: {top: 5, bottom: 5}, fillColor: GRAY}}
            ]
          }
          return [
            {content: item.insurance, styles: {cellPadding: {left: 35}}},
            {content: item.bilang},
            {content: item.percent}
          ]
        });

        const sampleBody = [
          // male and female insurance list
          [{content: "Both Male and Female", colSpan: 3, styles: {fontStyle: "bold", fontSize: 12, cellPadding: {left: 25, top: 5, bottom: 10}}}],
          ...maleAndFemale(),
          
          
          // gender based data
          [{content: "By Sex", colSpan: 3, styles: {fontStyle: "bold", fontSize: 12, cellPadding: {left: 25, top: 5, bottom: 10}}}],


          // female insurance list
          
          ...female(),
          
          // male insurance list
          ...male(),
          [
            {content: "Total", styles: {fontStyle: "bold", fontSize: 10, cellPadding: {left: 35, top: 10, bottom: 10}}},
            {content: totalEntries, styles: {fontStyle: "bold", fontSize: 10, cellPadding: {top: 10, bottom: 10}}}
          ],
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY:100,
          head: head,
          body: sampleBody.length !== 0 ?  sampleBody : [Array(mainHead.length).fill("")],
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 1.5,
              bottom: 1.5
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = 'bolditalic'
              data.cell.styles.cellPadding = {
                top: 20,
                right: 0,
                bottom: 15,
                left: 10,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(2.5);
            doc.setDrawColor(0, 0, 139); // Blue
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[6] Kalagayang Pangkalusugan: Gulayan, Halamang Gamot, Iodized Salt, pagkain ng 3 beses/araw") {
        const title = "Table 18. Bilang ng Pamilyang Nagtatanim ng Halamang Gamot sa Barangay";
        const dateToday = new Date();
        createFormTitle(doc, title, dateToday, barangayName, municipalName, provinceName, padding);

        const head = [
          [
            "Uri",
            "Bilang",
            "%"
          ]
        ];

        const H5 = fetchedData[0].find(item => item.question_code === 'H5');
        const H9 = fetchedData[0].find(item => item.question_code === 'H9');
        const H11 = fetchedData[0].find(item => item.question_code === 'H11');

        const qAndA = [
          {
            question: "Mga Gulayan sa Likod ng Bahay",
            answers: [
              {content: "Meron", count: H11.oo_bilang, percent: H11.oo_percent}, 
              {content: "Wala", count: H11.hindi_bilang, percent: H11.hindi_percent}, 
            ],
            summary: ["Kabuuan", H11.total, 100.00]
          },
          {
            question: "Eat three meals everyday",
            answers: [
              {content: "Oo", count: H5.oo_bilang, percent: H5.oo_percent}, 
              {content: "Hindi", count: H5.hindi_bilang, percent: H5.hindi_percent}, 
            ],
            summary: ["Kabuuan", H5.total, 100.00]
          },
          {
            question: "May Tanim na Halamang Gamot",
            answers: [
              {answer: "Meron", count: H9.oo_bilang, percent: H9.oo_percent},
              {answer: "Wala", count: H9.hindi_bilang, percent: H9.hindi_percent},
            ],
            summary: ["Kabuuan", H9.total, 100.00]
          },
          {
            question: "Mga Uri ng Halamang Gamot",
            answers: fetchedData[1].slice(0, fetchedData[1].length - 1).map((item, index) => 
              ({answer: item.tanim, count: item.bilang, percent: item.percent})
            ),
            summary: Object.keys(fetchedData).length !== 1 ? ["Kabuuan", fetchedData[1][fetchedData[1].length - 1].bilang, 100.00] : []
          }
        ]

        const sampleBody = createSampleBody(qAndA, false);
        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 125,
          head: head,
          body: sampleBody.length !== 0 ?  sampleBody : [Array(head[0].length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 10,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "right" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "right" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = [0, 0, 0];
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 2,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[7] Kalagayang Pangnutrisyon, Kalusugan at Pagpapasuso ng Batang 0-6 Taong Gulang") {
        const title = "Table 19. Kalagayang Pangnutrisyon at Kalusugan ng mga Batang Edad 0-\n23 buwan";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding + 10,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10., 95, { align: "left" });

        const head = [
          [
            "Kalagayan",
            "",
            "Bilang",
            "%"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 15, top: 15, bottom: 15}, halign: "left"}, colSpan: 4}]
        ];

        const purgaAtBakuna = [
          {
            title: {desc: "Kalagayan ng Pagpupurga"},
            subtitle: {desc: "Number of 12-23 month old children", count: fetchedData[0][fetchedData[0].length - 1].bilang},
            status: fetchedData[0].slice(0, fetchedData[0].length - 1).map((item, index) => ({content: item.descr, count: item.bilang, percent: item.percent})),
          },
          {
            title: {desc: "Bakunang Natanggap (0-11) buwan: ", count: fetchedData[1][fetchedData[1].length - 1].bilang},
            status: fetchedData[1].slice(0, fetchedData[1].length - 1).map((item, index) => ({content: item.descr, count: item.bilang, percent: item.percent})),
          },
          {
            title: {desc: "Bitamina at Mineral Natanggap (6-23 buwan): ", count: fetchedData[2][fetchedData[2].length - 1].bilang},
            status: fetchedData[2].slice(0, fetchedData[2].length - 1).map((item, index) => ({content: item.vitamin, count: item.bilang, percent: item.percent})),
          },
        ]

        const tabulizePurgaAtBakuna = () => {
          return purgaAtBakuna.flatMap(item => {
            const rows = [];

            // Title row
            rows.push([
              { content: item.title.desc, colSpan: 2, styles: {fontStyle: "bold", cellPadding: {left: 15, top: 10, bottom: 10}}},
              { content: item.title.count ?? "", styles: { fontStyle: "bold", cellPadding: {top: 10, bottom: 10}} },
              ""
            ]);

            // Optional subtitle
            if (item.subtitle) {
              rows.push([
                { content: item.subtitle.desc, colSpan: 2, styles: { fontStyle: "bolditalic", cellPadding: { left: 15 } } },
                { content: item.subtitle.count, styles: { fontStyle: "bold" } },
                "" // empty cell to match colSpan=3 structure
              ]);
            }

            // Status rows
            rows.push(
              ...item.status.map((statusItem, index) => {
                const lastStatus = index === item.status.length - 1;
                return [
                { content: statusItem.content, colSpan: 2, styles: {cellPadding: {left: 20, bottom: lastStatus ? 10 : 5}, lineColor: BLUE, lineWidth: {bottom: lastStatus ? 2 : 0}}},
                { content: statusItem.count, styles: {cellPadding: {bottom: lastStatus ? 10 : 5}, lineColor: BLUE, lineWidth: {bottom: lastStatus ? 2 : 0}}},
                { content: statusItem.percent, styles: {cellPadding: {bottom: lastStatus ? 10 : 5}, lineColor: BLUE, lineWidth: {bottom: lastStatus ? 2 : 0}}}
              ]}
            ));

            return rows;
          });
        };

        const feedingPractices = [
          {title: "Feeding practices (0-23 months): ",
          subtitles: [
            {name: "Number of 0-23 month old children: ", count: fetchedData[4][5].bilang},
            {name: "Number of 0-5 month old children", count: fetchedData[4][6].bilang}
          ],
          status: [
            {content: "Number of children exclusively breastfeed", count: fetchedData[4][0].bilang, percent: fetchedData[4][0].percent, 
              details: fetchedData[3].map((item, index) => {
                if (index === 0) {
                  return ({desc: "Number of children EBF per", month: item.month_name, count: item.bilang, percent: `${item.percent}%`})
                } else {
                  return (
                    {month: item.month_name, count: item.bilang, percent: `${item.percent}%`}
                  )
                } 
              })
            },
            ...fetchedData[4].slice(1, 5).map((item, index) => {
              return ({content: item.feeding_status_name, count: item.bilang, percent: item.percent})
            })
          ]
          },
        ];

        const tabulizeFeedingPractices = () => {
          return feedingPractices.flatMap(item => {
            const rows = [];

            // Title row
            rows.push([
              { content: item.title, colSpan: 2, styles: { fontStyle: "bold", cellPadding: { left: 15, top: 10, bottom: 10 } } }
            ]);

            // Subtitles rows
            rows.push(
              ...item.subtitles.map(subtitle => [
                { content: subtitle.name, colSpan: 2, styles: { fontStyle: "bolditalic", cellPadding: { left: 15 } } },
                { content: subtitle.count, styles: {fontSyle: "bold"} }
              ])
            );

            // Status rows
            rows.push(
              ...item.status.flatMap((statusItem, index) => {
                const lastStatus = index === item.status.length - 1;
                const mainRow = [
                  { content: statusItem.content, colSpan: 2, styles: {cellPadding: {left: 20, bottom: lastStatus ? 10 : 5}, lineWidth: {bottom: lastStatus ? 2 : 0}, lineColor: BLUE} },
                  { content: statusItem.count, styles: {cellPadding: {bottom: lastStatus ? 10 : 5}, lineWidth: {bottom: lastStatus ? 2 : 0}, lineColor: BLUE}},
                  { content: statusItem.percent, styles: {cellPadding: {bottom: lastStatus ? 10 : 5}, lineWidth: {bottom: lastStatus ? 2 : 0}, lineColor: BLUE}, }
                ];

                // Add detail rows if available
                const detailRows = statusItem.details
                  ? statusItem.details.map((detail, index) => {
                    if (index !== 0) {
                      return [
                        { content: detail.month || "" },
                        { content: detail.count },
                        { content: detail.percent }
                      ]
                    } else {
                      return [
                        { content: detail.desc, rowSpan: 6,  styles: {cellPadding: {left: 50, right: 10}} },
                        { content: detail.month || "" },
                        { content: detail.count },
                        { content: detail.percent }
                      ]
                    }
                    
                  })
                  : [];

                return [mainRow, ...detailRows];
              })
            ); 

            return rows;
          });
        };

        const optData = () => {
          const sections = [];
          const weightForAge = fetchedData[5].filter(item => item.category === 'Weight for Age');
          const heightForAge = fetchedData[5].filter(item => item.category === 'Height for Age');
          const weightForHeightOverLength = fetchedData[5].filter(item => item.category === 'Weight for Height/Length');
          const totalRow = fetchedData[5][fetchedData[5].length - 1];

          sections.push({
            category: 'Weight for Age', ranges: ["0-59 months", "0-71 months"],
            status: weightForAge.map((item) => ({
              name: item.status, count1: item.bilang_1, percent1: item.percent_1, count2: item.bilang_2, percent2: item.percent_2
            })),
            total: {
              name: "TOTAL", count1: totalRow.bilang_1, count2: totalRow.bilang_2
            }
          })

          sections.push({
            category: 'Height for Age', ranges: ["0-59 months", "0-71 months"],
            status: heightForAge.map((item) => ({
              name: item.status, count1: item.bilang_1, percent1: item.percent_1, count2: item.bilang_2, percent2: item.percent_2
            })),
            total: {
              name: "TOTAL", count1: totalRow.bilang_1, count2: totalRow.bilang_2
            }
          })

          sections.push({
            category: 'Weight for Height/Length', ranges: ["0-59 months", "0-71 months"],
            status: weightForHeightOverLength.map((item) => ({
              name: item.status, count1: item.bilang_1, percent1: item.percent_1, count2: item.bilang_2, percent2: item.percent_2
            })),
            total: {
              name: "TOTAL", count1: totalRow.bilang_1, count2: totalRow.bilang_2
            }
          })

          return sections
        }


        const kalagayangPangnutrisyon = [
          {title: "Kalagayang pangnutriyson: "},
          ...optData()
        ]

        const tabulizeKalagayangPangnutrisyon = () => {
          return kalagayangPangnutrisyon.flatMap((item, index) => {
            const rows = [];

            if (index === 0) {
              rows.push([{content: item.title, colSpan: 4, styles: {cellPadding: {left: 10, top: 5, bottom: 5}, fontStyle: "bold"}}]);
            } else {
              // Title row
              rows.push([
                { content: item.category, colSpan: 2, styles: {cellPadding: {left: 10, top: 10, bottom: 5 }, fontStyle: "italic" } }
              ]);

              // Ranges rows
              rows.push(
                [
                  "", "", // empty cells to match four columns
                  { content: item.ranges[0], styles: { fontStyle: "bolditalic"} },
                  { content: item.ranges[1], styles: { fontStyle: "bolditalic"} }
                ]
              );

              // Status rows
              rows.push(
                ...item.status.map(sta => {
                  return [
                    { content: sta.name, colSpan: 2, styles: {cellPadding: { left: 15 } } },
                    { content: `${sta.count1} - ${sta.percent1}%`, styles: {halign: 'left' }},
                    { content: `${sta.count2} - ${sta.percent2}%`, styles: {halign: 'left' }}
                  ]})
              );

              // Total
              rows.push(
                [
                  {content: item.total.name, styles: {fontStyle: 'bolditalic', halign: 'center'}, colSpan: 2},
                  {content: item.total.count1, styles: {halign: 'left' }},
                  {content: item.total.count2, styles: {halign: 'left' }}
                ]
              )
            }
              

            return rows;
          });
        }

        const sampleBody = [
          ...tabulizePurgaAtBakuna(),
          ...tabulizeFeedingPractices(),
          ...tabulizeKalagayangPangnutrisyon()
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 110,
          head: head,
          body: sampleBody,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.3, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.3, halign: "left" }, // Kalagayan
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            3: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 6,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[8] Kalagayang COVID Vaccination") {
        const title = "Kalagayang COVID Vaccination ng Pamilya";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding + 10,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10, 85, { align: "left" });

        const head = [
          [
            "Kalagayan",
            "Bilang",
            "%"
          ],
        ];

        const data = [
          {status: "No", count: 80, percent: 16.91},
          {status: "3rd Dose", count: 22, percent: 4.65},
          {status: "1st Dose", count: 4, percent: 0.85},
          {status: "1st and 2nd Dose", count: 239, percent: 50.53}
        ]

        const sampleBody = [
          ...data.map(item => {
            return [
              {content: item.status, styles: {cellPadding: {left: 15, bottom: 7, top: 3}}},
              {content: item.count, styles: {cellPadding: {bottom: 7, top: 3}}},
              {content: item.percent, styles: {cellPadding: {bottom: 7, top: 3}}}
            ]
          }),
          [
            {content: "Kabuuan", styles: {fontStyle: "bold", cellPadding: {left: 10, top: 3}}},
            {content: 473, styles: {fontStyle: "bold"}},
            {content: 100.00, styles: {fontStyle: "bold"}}
          ]
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 110,
          head: head,
          body: sampleBody,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 6,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } 
    } else if (reportType === "Institutional Household, Death, and Migration Profile") {
      if (formName === "[1] Kaanyuan ng mga Hindi Residente sa Barangay" ) {
        const title = "Table 23. Kaanyuan ng mga Hindi Residente sa Barangay";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        // headers
        const head = [
          [
            "", 
            {content: "BILANG", colSpan: 3, styles: {fontStyle: "bolditalic", lineWidth: {bottom: 4}, lineColor: BLUE, cellPadding: {top: 5, bottom: 10}}}
          ],
          [
            {content: "KAANYUAN", styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 10}, lineColor: BLUE, lineWidth: {bottom: 6}}, }, 
            {content: "Lalake", styles: {fontStyle: "bolditalic", cellPadding: {top: 5, bottom: 10}, lineColor: BLUE, lineWidth: {bottom: 6}}, }, 
            {content: "Babae", styles: {fontStyle: "bolditalic", cellPadding: {top: 5, bottom: 10}, lineColor: BLUE, lineWidth: {bottom: 6}}, }, 
            {content: "Total", styles: {fontStyle: "bolditalic", cellPadding: {top: 5, bottom: 10}, lineColor: BLUE, lineWidth: {bottom: 6}}, }
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 0, top: 15, bottom: 15}, halign: "left"}, colSpan: 4}]
        ]

        const data = [
          {name: "Kabuuang Bilang ng Bahay", total: 0},
          {name: "Populasyon", lalake: 0, babae: 0, "total": 0},
          {name: "Empleyado", isIndented: true, babae: 0, lalake: 0},
          {name: "Estudyante", isIndented: true, babae: 0, lalake: 0},
          {name: "Relihiyon"},
          {name: "Kalagayang Sibil"},
          {name: "Mga Sakit"},
          {name: "Mga Kapansanan"},
          {name: "Membership sa mga Organisasyon"},
          {name: "Antas ng Pinag-aralan"},
          {name: "Hindi pa Nag-aaral", isIndented: true, lalake: 0, babae: 0, total: 0},
          {name: "Hindi nakapag-aral", isIndented: true, lalake: 0, babae: 0, total: 0}
        ];

        const sampleBody = [
          ...data.map(item => {
            return [
              {content: item.name, styles: {cellPadding: {left: item.isIndented ? 15 : 0, top: 15}}},
              {content: item.lalake ?? "", styles: {fontStyle: item.name === "Populasyon" ? "bold" : null, cellPadding: {top: 15}}},
              {content: item.babae ?? "", styles: {fontStyle: item.name === "Populasyon" ? "bold" : null, cellPadding: {top: 15}}},
              {content: item.total ?? "", styles: {fontStyle: item.name === "Populasyon" || item.name === "Kabuuang Bilang ng Bahay" ? "bold" : null, cellPadding: {top: 15}}}
            ]
          })
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 110,
          head: head,
          body: sampleBody,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.1333, halign: "left" }, // Kalagayan
            2: { cellWidth: contentWidth * 0.1333, halign: "center" }, // Bilang
            3: { cellWidth: contentWidth * 0.1333, halign: "center" }, // %
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[2] Number and Percent Distribution of Non Residents by Age group & Sex") {
        const title = "Table 24. Number and Percent Distribution of Non Residents by Age & Sex";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding + 10,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10, 85, { align: "left" });

        // headers
        const head = [
          [
            "",
            {content: "Lalake", colSpan: 2},
            {content: "Babae", colSpan: 2},
            {content: "Kabuuan"},
          ],
          [
            {content: "Edad"}, 
            {content: "Bilang"}, 
            {content: "%"}, 
            {content: "Bilang"},
            {content: "%"},
            ""
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 0, top: 10, bottom: 10}, halign: "left"}, colSpan: 4}]
        ]

        const data = fetchedData.map((item, index) => {
          return (
            {age: item.age, lalake_bilang: item.male_count, lalake_percent: item.male_percent, babae_bilang: item.female_count, babae_percent: item.female_percent, kabuuan: item.kabuuan}
          )
        })

        const sampleBody = [
          ...data.map((item, index) => {
            const lastItem = index === data.length - 1;
            return [
              {content: item.age, styles: {fontStyle: lastItem ? "bold": "normal", cellPadding: {top: 5, bottom: 5}}},
              {content: item.lalake_bilang, styles: {fontStyle: lastItem ? "bold": "normal", cellPadding: {top: 5, bottom: 5}}},
              {content: item.lalake_percent, styles: {fontStyle: lastItem ? "bold": "normal", cellPadding: {top: 5, bottom: 5}}},
              {content: item.babae_bilang, styles: {fontStyle: lastItem ? "bold": "normal", cellPadding: {top: 5, bottom: 5}}},
              {content: item.babae_percent, styles: {fontStyle: lastItem ? "bold": "normal", cellPadding: {top: 5, bottom: 5}}},
              {content: item.kabuuan, styles: {fontStyle: lastItem ? "bold": "normal", cellPadding: {top: 5, bottom: 5}}},
            ]
          })
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 100,
          head: head,
          body: sampleBody,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.25, halign: "center", styles: {fontStyle: "bold"} }, // edad
            1: { cellWidth: contentWidth * 0.125, halign: "center" }, // bilang ng lalaki
            2: { cellWidth: contentWidth * 0.125, halign: "center" }, // percent ng lalaki
            3: { cellWidth: contentWidth * 0.125, halign: "center" }, // bilang ng babae
            4: { cellWidth: contentWidth * 0.125, halign: "center" }, // percent ng babae
            5: { cellWidth: contentWidth * 0.25, halign: "center" }, // kabuuan
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 4,
                right: 0,
                bottom: 0,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 3,
                right: 0,
                bottom: 3,
                left: 0,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 5,
                right: 0,
                bottom: 14,
                left: 0,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[3] Bilang ng mga tao na umalis at namatay sa barangay") {
        const title = "Table 27. Bilang ng tao na umalis at namatay sa Barangay.";
        const dateToday = new Date();
        createFormTitle(doc, title, dateToday, barangayName, municipalName, provinceName, padding);

        const head = [
          [
            "Kalagayan",
            "Bilang",
            "%"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 10, top: 10, bottom: 10}, halign: "left"}, colSpan: 3}]
        ];

        const parseData = (data) => {
          if (Object.keys(data).length === 0) return [];
          const items = [];
          let prev_year = ''
          let diseases = [];
          for (let item of data) {
            if (prev_year === '') {
              prev_year = item.death_year;
            } else if (item.death_year !== prev_year) {
              items.push({
                year: prev_year, diseases: diseases
              });
              prev_year = item.death_year;
              diseases = []
            }
            diseases.push({
              name: item.sakit,
              count: item.bilang,
              percent: item.percent
            })
          }
          items.push({
            year: prev_year, diseases: diseases
          });

          return items;
        }

        const data = [
          {name: "Transferred", count: fetchedData[1][0].bilang},
          {name: "Died", count: fetchedData[0][fetchedData[0].length - 1].bilang},
          {description: "Dahilan ng pagkamatay", list: parseData(fetchedData[0].slice(0, fetchedData[0].length - 1))}
        ]
        

        const sampleBody = [
          // data from transfer of people
          [{content: data[0].name, styles: {cellPadding: {left: 15, top: 10, bottom: 3}, fontStyle: "bolditalic"}}, {content: data[0].count, styles: {fontStyle: "bolditalic"}}],
          [{content: data[1].name, styles: {cellPadding: {left: 15, bottom: 10, top: 3}, fontStyle: "bolditalic"}}, {content: data[1].count, styles: {fontStyle: "bolditalic"}}],
          [{content: data[2].description, styles: {cellPadding: {left: 25}}}],
          ...data[2].list.flatMap((item, index) => {
            const rows = [];

            rows.push([
              {content: `Year Died: ${item.year}`, styles: {cellPadding: {left: 25, top: 5}}},
            ])

            rows.push(
              ...item.diseases.map((disease) => [
                {content: disease.name, styles: {cellPadding: {left: 50, top: 10}}},
                {content: disease.count, styles: {cellPadding: {top: 10}}},
                {content: disease.percent, styles: {cellPadding: {top: 10}}}
              ])
            )

            return rows;
          }),
          [
            {content: "Subtotal", styles: {fontStyle: "bold", cellPadding: {left: 65, top: 10}}},
            {content: fetchedData[0][fetchedData[0].length - 1].bilang, styles: {fontStyle: "bold", cellPadding: {top: 10}}},
          ]
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 125,
          head: head,
          body: sampleBody,
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = [0, 0, 0];
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 2,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } 
    } else if (reportType === "Socio-economic Profile") {
      if (formName === "[1a] Barangay populasyon ayon sa edad at kasarian") {
        const title = "Table 1. Populasyon ng Barangay ayon sa Edad at Kasarian";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding + 10,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10, 85, { align: "left" });

        // headers
        const head = [
          [
            "",
            {content: "Lalake", colSpan: 2},
            {content: "Babae", colSpan: 2},
            {content: "Kabuuan", colSpan: 2},
          ],
          [
            {content: "Edad"}, 
            {content: "Bilang"}, 
            {content: "%"}, 
            {content: "Bilang"},
            {content: "%"},
            {content: "Bilang"},
            {content: "%"},
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 0, top: 10, bottom: 20}, halign: "left"}, colSpan: 7}]
        ]

        const kabuuan_lalake_bilang = fetchedData.reduce((total, item) => total + Number(item.lalake_bilang), 0);
        const kabuuan_babae_bilang = fetchedData.reduce((total, item) => total + Number(item.babae_bilang), 0);
        const kabuuan_bilang = fetchedData.reduce((total, item) => total + Number(item.kabuuan_bilang), 0);

        const body = [
          ...fetchedData.map((item, index) => {
            return [
              {content: item.age_range, styles: {fontStyle: "bold", cellPadding: {top: 5}}},
              {content: item.lalake_bilang, styles: {fontStyle: "normal", cellPadding: {top: 5}}},
              {content: item.lalake_percent, styles: {fontStyle: "normal", cellPadding: {top: 5}}},
              {content: item.babae_bilang, styles: {fontStyle: "normal", cellPadding: {top: 5}}},
              {content: item.babae_percent, styles: {fontStyle: "normal", cellPadding: {top: 5}}},
              {content: item.kabuuan_bilang, styles: {fontStyle: "normal", cellPadding: {top: 5}}},
              {content: item.kabuuan_percent, styles: {fontStyle: "normal", cellPadding: {top: 5}}},
            ]
          }),
          [
            {content: "Barangay Kabuuan: ", styles: {fontStyle: "bolditalic", cellPadding: {top: 5}}},
            {content: kabuuan_lalake_bilang, styles: {fontStyle: "bolditalic", cellPadding: {top: 5}}},
            {content: kabuuan_lalake_bilang !== 0 ? 100 : 0, styles: {fontStyle: "bolditalic", cellPadding: {top: 5}}},
            {content: kabuuan_babae_bilang, styles: {fontStyle: "bolditalic", cellPadding: {top: 5}}},
            {content: kabuuan_babae_bilang !== 0 ? 100 : 0, styles: {fontStyle: "bolditalic", cellPadding: {top: 5}}},
            {content: kabuuan_bilang, styles: {fontStyle: "bolditalic", cellPadding: {top: 5}}},
            {content: kabuuan_bilang !== 0 ? 100 : 0, styles: {fontStyle: "bolditalic", cellPadding: {top: 5}}},
          ]
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.22, halign: "right", styles: {fontStyle: "bold"} }, // edad
            1: { cellWidth: contentWidth * 0.13, halign: "center" }, // bilang ng lalaki
            2: { cellWidth: contentWidth * 0.13, halign: "center" }, // percent ng lalaki
            3: { cellWidth: contentWidth * 0.13, halign: "center" }, // bilang ng babae
            4: { cellWidth: contentWidth * 0.13, halign: "center" }, // percent ng babae
            5: { cellWidth: contentWidth * 0.13, halign: "center" }, // bilang ng kabuuan
            6: { cellWidth: contentWidth * 0.13, halign: "center" }, // percent ng kabuuan
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 4,
                right: 0,
                bottom: 0,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 3,
                right: 0,
                bottom: 3,
                left: 0,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 5,
                right: 0,
                bottom: 14,
                left: 0,
              };
            } else if (data.section === "body" && data.row.index === data.table.body.length - 2) {
              data.cell.styles.cellPadding = {
                top: 5,
                bottom: 15
              }
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {bottom: 8};
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[1b] Purok populasyon ayon sa edad at kasarian") {
        const title = "Table 1. Populasyon ng Barangay ayon sa Edad at Kasarian";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding + 10,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10, 85, { align: "left" });

        // headers
        const head = [
          [
            "",
            {content: "Lalake", colSpan: 2},
            {content: "Babae", colSpan: 2},
            {content: "Kabuuan", colSpan: 2},
          ],
          [
            {content: "Edad"}, 
            {content: "Bilang"}, 
            {content: "%"}, 
            {content: "Bilang"},
            {content: "%"},
            {content: "Bilang"},
            {content: "%"},
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 0, top: 10, bottom: 10}, halign: "left"}, colSpan: 7}]
        ]

        const contentWidth = pageWidth - (padding * 2);
        let barangay_lalake_bilang = 0;
        let barangay_babae_bilang = 0;
        let barangay_kabuuan_bilang = 0;

        const parseData = () => {
          const items = [];
          let prev_purok = null;
          let details = []
          fetchedData.forEach((item, index) => {
            if (prev_purok === null) {
              prev_purok = item.sitio
            } else if (item.sitio !== prev_purok) {
              items.push({
                purok: {purok: prev_purok},
                details: details
              })
              prev_purok = item.sitio;
              details = [];
            }
            details.push({
              age_range: item.age_range,
              lalake_bilang: item.lalake_bilang,
              lalake_percent: item.lalake_percent,
              babae_bilang: item.babae_bilang,
              babae_percent: item.babae_percent,
              kabuuan_bilang: item.kabuuan_bilang,
              kabuuan_percent: item.kabuuan_percent
            })
          })
          items.push({
            purok: {purok: prev_purok},
            details: details
          })
          return items;
        }
        

        const parsedItems = parseData(); 

        if (Object.keys(parsedItems).length !== 0) {
          parsedItems.forEach((item, index) => {
            const lastItem = index === parsedItems.length - 1; 
            const body = [];

            body.push(
              [{content: `Purok: ${item.purok.purok}`, styles: {halign: "left", fontStyle: "bolditalic", cellPadding: {left: 10, top: 10}}}]
            );

            body.push(
              ...item.details.map((age, index) => {
                return [
                  {content: age.age_range, styles: {fontStyle: "bold"}},
                  {content: age.lalake_bilang},
                  {content: age.lalake_percent},
                  {content: age.babae_bilang},
                  {content: age.babae_percent},
                  {content: age.kabuuan_bilang},
                  {content: age.kabuuan_percent}
                ]
              })
            );
            const purok_lalake_bilang = item.details.reduce((total, item) => total + Number(item.lalake_bilang), 0); 
            barangay_lalake_bilang += purok_lalake_bilang;
            const purok_babae_bilang = item.details.reduce((total, item) => total + Number(item.babae_bilang), 0);
            barangay_babae_bilang += purok_babae_bilang;
            const purok_kabuuan_bilang = item.details.reduce((total, item) => total + Number(item.kabuuan_bilang), 0);
            barangay_kabuuan_bilang += purok_kabuuan_bilang;

            body.push([
              {content: "Kabuuan Purok", styles: {halign: "left", fontStyle: "bolditalic", cellPadding: {top: 5, bottom: 5}, lineWidth: {top: 3}, lineColor: GRAY}},
              {content: purok_lalake_bilang, styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}, lineWidth: {top: 3}, lineColor: GRAY}},
              {content: 100, styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}, lineWidth: {top: 3}, lineColor: GRAY}},
              {content: purok_babae_bilang, styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}, lineWidth: {top: 3}, lineColor: GRAY}},
              {content: 100, styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}, lineWidth: {top: 3}, lineColor: GRAY}},
              {content: purok_kabuuan_bilang, styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}, lineWidth: {top: 3}, lineColor: GRAY}},
              {content: 100, styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}, lineWidth: {top: 3}, lineColor: GRAY}}
            ])

            if (lastItem) {
              const barangay_lalake_percent = parseFloat(((barangay_lalake_bilang / barangay_kabuuan_bilang) * 100).toFixed(2));
              const barangay_babae_percent = parseFloat(((barangay_babae_bilang / barangay_kabuuan_bilang) * 100).toFixed(2));
              body.push([
                {content: "Barangay Kabuuan", styles: {halign: "left", fontStyle: "bolditalic", cellPadding: {top: 15, bottom: 3}}},
                {content: barangay_lalake_bilang, styles: {fontStyle: "bold", cellPadding: {top: 15, bottom: 5}}},
                {content: barangay_lalake_percent, styles: {fontStyle: "bold", cellPadding: {top: 15, bottom: 5}}},
                {content: barangay_babae_bilang, styles: {fontStyle: "bold", cellPadding: {top: 15, bottom: 5}}},
                {content: barangay_babae_percent, styles: {fontStyle: "bold", cellPadding: {top: 15, bottom: 5}}},
                {content: barangay_kabuuan_bilang, styles: {fontStyle: "bold", cellPadding: {top: 15, bottom: 5}}},
                {content: 100, styles: {fontStyle: "bold", cellPadding: {top: 15, bottom: 5}}}
              ])
            }

            autoTable(doc, {
              startY: 100,
              head: head,
              body: body,
              theme: "grid",
              showHead: "firstPage",
              margin: {
                left: padding,
                right: pageWidth - padding,
                bottom: padding + 20,
              },
              styles: {
                fontSize: 10,
                cellPadding: {
                  left: 0,
                  top: 2,
                  bottom: 2
                },
                overflow: "linebreak",
                lineWidth: 0,
                lineColor: [0, 0, 0],
                textColor: [0, 0, 0],
              },
              headStyles: {
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
                halign: "center",
                valign: "center",
                lineColor: [0, 0, 0],
                fontSize: 10, 
              },
              columnStyles: {
                0: { cellWidth: contentWidth * 0.22, halign: "right", styles: {fontStyle: "bold"} }, // edad
                1: { cellWidth: contentWidth * 0.13, halign: "center" }, // bilang ng lalaki
                2: { cellWidth: contentWidth * 0.13, halign: "center" }, // percent ng lalaki
                3: { cellWidth: contentWidth * 0.13, halign: "center" }, // bilang ng babae
                4: { cellWidth: contentWidth * 0.13, halign: "center" }, // percent ng babae
                5: { cellWidth: contentWidth * 0.13, halign: "center" }, // bilang ng kabuuan
                6: { cellWidth: contentWidth * 0.13, halign: "center" }, // percent ng kabuuan
              },
              didParseCell: function (data) {
                if (data.section === "head" && data.row.index === 0) {
                  data.cell.styles.fontStyle = "bold";
                  data.cell.styles.lineColor = GRAY;
                  data.cell.styles.lineWidth = {
                    top: 4,
                    right: 0,
                    bottom: 0,
                    left: 0
                  }
                  data.cell.styles.cellPadding = {
                    top: 3,
                    right: 0,
                    bottom: 3,
                    left: 0,
                  };
                } else if (data.section === "head" && data.row.index === 1) {
                  data.cell.styles.fontStyle = "bold";
                  data.cell.styles.lineColor = GRAY;
                  data.cell.styles.lineWidth = {
                    top: 0,
                    right: 0,
                    bottom: 8,
                    left: 0
                  }
                  data.cell.styles.cellPadding = {
                    top: 5,
                    right: 0,
                    bottom: 14,
                    left: 0,
                  };
                }
              },
              didDrawPage: function (data) {
                doc.setLineWidth(3);
                doc.setDrawColor(211, 211, 211);
                doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
              }
            });

            if (!lastItem) {
              doc.addPage();

              const title = "Table 1. Populasyon ng Barangay ayon sa Edad at Kasarian";
              const dateToday = new Date();
              doc.setFontSize(12);
              doc.setFont(undefined, "bold");
              doc.text(
                title,
                padding + 10,
                70,
                { align: "left" }
              );

              const formattedDate = formatDateToDDMMMYY(dateToday);
              doc.setFontSize(10);
              doc.setFont(undefined, "italic");
              doc.text(formattedDate, padding + 10, 85, { align: "left" });
            }
          });
        }
        
      } else if (formName === "[1c] Number and percent distribution of the population by age sex") {
        const title = "Table 2. Number and Percent Distribution of the Population by Age Group and Sex";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        // headers
        const head = [
          [
            "",
            {content: "Lalake", colSpan: 2},
            {content: "Babae", colSpan: 2},
            {content: "Kabuuan", colSpan: 2},
          ],
          [
            {content: "Edad"}, 
            {content: "Bilang"}, 
            {content: "%"}, 
            {content: "Bilang"},
            {content: "%"},
            {content: "Bilang"},
            {content: "%"},
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 0, top: 10, bottom: 20}, halign: "left"}, colSpan: 7}]
        ]

        const pangkalahatan_lalake_bilang = fetchedData.reduce((total, item) => total + Number(item.lalake_bilang), 0);
        const pangkalahatan_babae_bilang = fetchedData.reduce((total, item) => total + Number(item.babae_bilang), 0);
        const pangkalahatan_kabuuan_bilang = fetchedData.reduce((total, item) => total + Number(item.kabuuan_bilang), 0);

        const body = [
          ...fetchedData.map((item) => {
            return [
              {content: item.age_range, styles: {fontStyle: "bold", cellPadding: {top: 5, right: 30}}},
              {content: item.lalake_bilang, styles: {fontStyle: "normal", cellPadding: {top: 5}}},
              {content: item.lalake_percent, styles: {fontStyle: "normal", cellPadding: {top: 5}}},
              {content: item.babae_bilang, styles: {fontStyle: "normal", cellPadding: {top: 5}}},
              {content: item.babae_percent, styles: {fontStyle: "normal", cellPadding: {top: 5}}},
              {content: item.kabuuan_bilang, styles: {fontStyle: "normal", cellPadding: {top: 5}}},
              {content: item.kabuuan_percent, styles: {fontStyle: "normal", cellPadding: {top: 5}}},
            ]
          }),
          [
            {content: "All Ages", styles: {fontStyle: "bold", cellPadding: {top: 15, right: 30}}},
            {content: pangkalahatan_lalake_bilang, styles: {fontStyle: "bold", cellPadding: {top: 15}}},
            {content: pangkalahatan_lalake_bilang !== 0 ? 100 : 0, styles: {fontStyle: "bold", cellPadding: {top: 15}}},
            {content: pangkalahatan_babae_bilang, styles: {fontStyle: "bold", cellPadding: {top: 15}}},
            {content: pangkalahatan_babae_bilang !== 0 ? 100 : 0, styles: {fontStyle: "bold", cellPadding: {top: 15}}},
            {content: pangkalahatan_kabuuan_bilang, styles: {fontStyle: "bold", cellPadding: {top: 15}}},
            {content: pangkalahatan_kabuuan_bilang !== 0 ? 100 : 0, styles: {fontStyle: "bold", cellPadding: {top: 15}}},
          ]
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.22, halign: "right", styles: {fontStyle: "bold"} }, // edad
            1: { cellWidth: contentWidth * 0.13, halign: "center" }, // bilang ng lalaki
            2: { cellWidth: contentWidth * 0.13, halign: "center" }, // percent ng lalaki
            3: { cellWidth: contentWidth * 0.13, halign: "center" }, // bilang ng babae
            4: { cellWidth: contentWidth * 0.13, halign: "center" }, // percent ng babae
            5: { cellWidth: contentWidth * 0.13, halign: "center" }, // bilang ng kabuuan
            6: { cellWidth: contentWidth * 0.13, halign: "center" }, // percent ng kabuuan
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 4,
                right: 0,
                bottom: 0,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 3,
                right: 0,
                bottom: 3,
                left: 0,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 5,
                right: 0,
                bottom: 14,
                left: 0,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[1d] Number and percent distribution of the population by age (yearly) sex") {
        const title = "Table 2. Number and Percent Distribution of the Population by Age (Yearly) & Sex";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding + 10,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10, 85, { align: "left" });

        // headers
        const head = [
          [
            "",
            {content: "Lalake", colSpan: 2},
            {content: "Babae", colSpan: 2},
            {content: "Kabuuan"},
          ],
          [
            {content: "Edad"}, 
            {content: "Bilang"}, 
            {content: "%"}, 
            {content: "Bilang"},
            {content: "%"},
            ""
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 0, top: 10, bottom: 10}, halign: "left"}, colSpan: 4}]
        ]

        const kabuuan_lalake_bilang = fetchedData.reduce((total, item) => total + Number(item.lalake_bilang), 0);
        const kabuuan_babae_bilang = fetchedData.reduce((total, item) => total + Number(item.babae_bilang), 0);
        const kabuuan_bilang = fetchedData.reduce((total, item) => total + Number(item.kabuuan_bilang), 0);
        

        const body = [
          ...fetchedData.map((item, index) => {
            return [
              {content: item.age_label, styles: {fontStyle: item.age === "more than 100" || item.age === "0-11 mos." ? "bold" : "normal", cellPadding: {top: 5, bottom: 5}}},
              {content: item.lalake_bilang, styles: {fontStyle: "normal", cellPadding: {top: 5, bottom: 5}}},
              {content: item.lalake_percent, styles: {fontStyle: "normal", cellPadding: {top: 5, bottom: 5}}},
              {content: item.babae_bilang, styles: {fontStyle: "normal", cellPadding: {top: 5, bottom: 5}}},
              {content: item.babae_percent, styles: {fontStyle: "normal", cellPadding: {top: 5, bottom: 5}}},
              {content: item.kabuuan_bilang, styles: {fontStyle: "normal", cellPadding: {top: 5, bottom: 5}}},
            ]
          }),
          [
            {content: "All ages", styles: {fontStyle: "bold", cellPadding: {top: 15}}}, 
            {content: kabuuan_lalake_bilang, styles: {fontStyle: "bold", cellPadding: {top: 15}}},
            {content: kabuuan_lalake_bilang !== 0 ? 100.00 : 0, styles: {fontStyle: "bold", cellPadding: {top: 15}}},
            {content: kabuuan_babae_bilang, styles: {fontStyle: "bold", cellPadding: {top: 15}}},
            {content: kabuuan_babae_bilang !== 0 ? 100.00 : 0, styles: {fontStyle: "bold", cellPadding: {top: 15}}},
            {content: kabuuan_bilang, styles: {fontStyle: "bold", cellPadding: {top: 15}}}
          ]
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.25, halign: "center", styles: {fontStyle: "bold",} }, // edad
            1: { cellWidth: contentWidth * 0.125, halign: "center" }, // bilang ng lalaki
            2: { cellWidth: contentWidth * 0.125, halign: "center" }, // percent ng lalaki
            3: { cellWidth: contentWidth * 0.125, halign: "center" }, // bilang ng babae
            4: { cellWidth: contentWidth * 0.125, halign: "center" }, // percent ng babae
            5: { cellWidth: contentWidth * 0.25, halign: "center" }, // kabuuan
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 4,
                right: 0,
                bottom: 0,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 3,
                right: 0,
                bottom: 3,
                left: 0,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 5,
                right: 0,
                bottom: 14,
                left: 0,
              };
            } else if (data.section === "body" && data.row.index === data.table.body.length - 1) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.cellPadding = {
                top: 10,
                right: 0,
                bottom: 0,
                left: 0,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === '[2] Bilang ng rehistradong botante at "Live Births" sa barangay') {
        const title = 'Table 3. Bilang ng Rehistradong Botante at "Live Births" sa Barangay';
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding + 10,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10, 85, { align: "left" });

        const head1 = [
          [
            {content: "Kalagayan", colSpan: 7, styles: {halign: "left", cellPadding: {top: 5, bottom: 10, left: 40}, fontSize: 12, lineWidth: {bottom: 6}, lineColor: BLUE}},
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 7, styles: {fontStyle: 'bolditalic', cellPadding: {left: 15, top: 10, bottom: 10}, halign: "left"}}],
          [
            {content: "Registered Voter", styles: {halign: "left", fontStyle: "bolditalic", cellPadding: {top: 5, bottom: 15, left: 25}}},
            {content: "Male", colSpan: 2, styles: {halign: "center", fontStyle: "bolditalic", cellPadding: {top: 5, bottom: 15}}},
            {content: "Female", colSpan: 2, styles: {halign: "center", fontStyle: "bolditalic", cellPadding: {top: 5, bottom: 15}}},
            {content: "Total", colSpan: 2, styles: {halign: "center", fontStyle: "bolditalic", cellPadding: {top: 5, bottom: 15}}}
          ]
        ]

        const kabuuan_lalake_bilang = fetchedData[0].reduce((total, item) => total + Number(item.lalaki_bilang), 0);
        const kabuuan_lalake_percent = fetchedData[0].reduce((total, item) => total + Number(item.lalake_percent), 0).toFixed(2);
        const kabuuan_babae_bilang = fetchedData[0].reduce((total, item) => total + Number(item.babae_bilang), 0);
        const kabuuan_babae_percent = fetchedData[0].reduce((total, item) => total + Number(item.babae_percent), 0).toFixed(2);
        const kabuuan_bilang = fetchedData[0].reduce((total, item) => total + Number(item.kabuuan_bilang), 0);

        const body1 = [
          ...fetchedData[0].map((item, index) => {
            return [
              {content: item.status, styles: {cellPadding: {left: 30}}},
              {content: item.lalaki_bilang, styles: {cellPadding: {left: 0}}},
              {content: `${item.lalake_percent}%`, styles: {cellPadding: {left: 0}}},
              {content: item.babae_bilang, styles: {cellPadding: {left: 0}}},
              {content: `${item.babae_percent}%`, styles: {cellPadding: {left: 0}}},
              {content: item.kabuuan_bilang, styles: {cellPadding: {left: 0}}},
              {content: `${item.kabuuan_percent}%`, styles: {cellPadding: {left: 0}}},
            ]
          }),
          [
            {content: "Barangay Kabuuan: ", styles: {fontStyle: "bolditalic", cellPadding: {left: 40, top: 5, bottom: 5}}}, 
            {content: kabuuan_lalake_bilang, styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}}}, 
            {content: `${kabuuan_lalake_percent}%`, styles: {fontStyle: "bold",cellPadding: {top: 5, bottom: 5}}}, 
            {content: kabuuan_babae_bilang, styles: {fontStyle: "bold",cellPadding: {top: 5, bottom: 5}}}, 
            {content: `${kabuuan_babae_percent}%`, styles: {fontStyle: "bold",cellPadding: {top: 5, bottom: 5}}}, 
            {content: kabuuan_bilang, styles: {fontStyle: "bold",cellPadding: {top: 5, bottom: 5}}},
            {content: '100.0%', styles: {fontStyle: "bold",cellPadding: {top: 5, bottom: 5}}}
          ],
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 90,
          head: head1,
          body: body1,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.4, halign: "left", styles: {fontStyle: "bold"} }, // Status
            1: { cellWidth: contentWidth * 0.1, halign: "center" }, // Male - bilang
            2: { cellWidth: contentWidth * 0.1, halign: "center" }, // Male - percent
            3: { cellWidth: contentWidth * 0.1, halign: "center" }, // Female - bilang
            4: { cellWidth: contentWidth * 0.1, halign: "center" }, // Female - percent
            5: { cellWidth: contentWidth * 0.1, halign: "center" }, // Total - bilang
            6: { cellWidth: contentWidth * 0.1, halign: "center" }, // Total - percent
          },
          didParseCell: function (data) {

          }
        })

        const head2 = [
            [{content: "Status of Live Birth Registration", colSpan: 7, styles: {halign: "left", cellPadding: {top: 5, bottom: 10, left: 40}, fontSize: 12, lineWidth: {top: 3}, lineColor: [0, 0, 0]}},]
        ]

        const body2 = fetchedData[1].map((item, index) => {
          if (index === fetchedData[1].length - 1) {
            return [
              {content: item.answer, styles: {cellPadding: {left: 40, top: 5, bottom: 5}, fontStyle: "bolditalic"}}, 
              {content: item.male_bilang, styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}}}, 
              {content: `${item.male_percent}%`, styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}}}, 
              {content: item.female_bilang, styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}}}, 
              {content: `${item.female_percent}%`, styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}}}, 
              {content: item.kabuuan, styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}}},
              {content: `${item.kabuuan_percent}%`, styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}}}
            ]
          }
          return [
            {content: item.answer, styles: {cellPadding: {left: 30}}},
            {content: item.male_bilang},
            {content: `${item.male_percent}%`},
            {content: item.female_bilang},
            {content: `${item.female_percent}%`},
            {content: item.kabuuan},
            {content: `${item.kabuuan_percent}%`}
          ]
        })

        autoTable(doc, {
          startY: doc.lastAutoTable.finalY + 10,
          head: head2,
          body: body2,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.4, halign: "left", styles: {fontStyle: "bold"} }, // Status
            1: { cellWidth: contentWidth * 0.1, halign: "center" }, // Male - bilang
            2: { cellWidth: contentWidth * 0.1, halign: "center" }, // Male - percent
            3: { cellWidth: contentWidth * 0.1, halign: "center" }, // Female - bilang
            4: { cellWidth: contentWidth * 0.1, halign: "center" }, // Female - percent
            5: { cellWidth: contentWidth * 0.1, halign: "center" }, // Total - bilang
            6: { cellWidth: contentWidth * 0.1, halign: "center" }, // Total - percent
          },
        })
      } else if (formName === "[3a] Demographic data by barangay (Population, No. of Houses and Families, Religion, Organization, Civil Status, Relation to HH)") {
        const title = "Table 4. Kaanyuan ng Pamilya sa Barangay";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(title, padding, 70, { align: "left" });

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const head = [["Kaanyuan", "Bilang", "%"]];

        const femaleHeads = Number(fetchedData[0][13].bilang);
        const maleHeads =Number(fetchedData[0][14].bilang);
        const totalFamily = fetchedData[0][7].bilang;
        const houses = fetchedData[0][8].bilang;
        const average = fetchedData[0][9].bilang;
        const minimum = fetchedData[0][10].bilang;
        const maximum = fetchedData[0][11].bilang;
        const ageDependencyRatio = fetchedData[0][12].bilang;
        const population = fetchedData[0][6].bilang;
        

        const generalInfo = [
          // population
          {
            title: {name: "Populasyon", count: population},
            division: {name: "Sex/Gender"},
            categories: fetchedData[0].slice(0, 6).map((item, index) => (
              { name: item.sex, count: item.bilang}
            )),
          },
          // kabuuang bilang
          { title: {name: "Kabuuang bilang ng bahay", count: houses}},

          // kabuuang pamilya
          {title: {name: "Kabuuang bilang ng pamilya", count: totalFamily}},

          // family size
          {
            title: {name: "Family Size"}, 
            categories: [
              {name: "Average", count: average},
              {name: "Minimum", count: minimum}, 
              {name: "Maximum", count: maximum}
            ]
          },

          // age dependency ratio
          {title: {name: "Age Dependency Ratio", count: ageDependencyRatio}},

          // Kasarian ng Puno ng pamilya
          {
            title: {name: "Kasarian ng Puno ng Pamilya"},
            categories: [
              {name: "Babae", count: femaleHeads, percent: Math.round(femaleHeads / (femaleHeads + maleHeads) * 100, 2)},
              {name: "Lalake", count: maleHeads, percent:  Math.round(maleHeads / (femaleHeads + maleHeads) * 100, 2)},
              {name: "Kabuuan", count: (femaleHeads + maleHeads)} 
            ]
          }
        ];

        const migrationInfo = {
          title: "Migration status of families",
          status: fetchedData[1].slice(0, fetchedData[1].length - 1).map((item, index) => (
            {name: item.migration_status, count: item.bilang, percent: item.percent}
          )),
          summary: {name: "Total", count: fetchedData[1][fetchedData[1].length - 1].bilang, percent: "100%"}
        }

        const durationOfStay = {
          title: "Number of Years Staying in the Barangay",
          header: {head1: "Number of Years", head2: "Frequency", head3: "Percentage"},
          categories: fetchedData[2].map((item, index) => (
            {name: item.year_range, frequency: item.frequency, percentage: item.percentage}
          )),
          summary: {name: "Average Length of Stay in the Barangay (Years):", average: fetchedData[2].length !== 0 ? fetchedData[2][0].average : 0}
        }

        const kalagayangSibil = {
          title: "Kalagayang Sibil",
          genders: [
            {gender: {name: "Male"},
              status: fetchedData[3].filter(item => item.sex === 'Male' && item.civil_status !== 'Total').map(item => (
                {name: item.civil_status, count: item.bilang, percent: item.percent}
              ))
            },
            {gender: {name: "Female"},
              status: fetchedData[3].filter(item => item.sex === 'Female' && item.civil_status !== 'Total').map(item => (
                {name: item.civil_status, count: item.bilang, percent: item.percent}
              ))
            } 
          ],
          summary: {name: "Total", count: fetchedData[3].filter(item => item.sex === 'Both Sex' && item.civil_status === 'Total')[0].bilang}
        }

        const familyHeadWithJobs = {
          title: "Bilang ng puno ng pamilya na may trabaho ayon sa kalagayang sibil",
          headers: {head1: "Kalagayang sibil", head2: "Bilang"},
          genders: [
            {
              gender: {name: "Male", count: fetchedData[4].filter(item => item.sex === 'Male' && item.civil_status === 'Total')[0].bilang},
              status: fetchedData[4].filter(item => item.sex === 'Male' && item.civil_status !== 'Total').map((item, index) => (
                {name: item.civil_status, count: item.bilang, percent: item.percent}
              ))
            },
            {
              gender: {name: "Female", count: fetchedData[4].filter(item => item.sex === 'Female' && item.civil_status === 'Total')[0].bilang},
              status: fetchedData[4].filter(item => item.sex === 'Female' && item.civil_status !== 'Total').map((item, index) => (
                {name: item.civil_status, count: item.bilang, percent: item.percent}
              ))
            },
          ],
          summary: {name: "Total", count: fetchedData[4].filter(item => item.sex === 'Both Sex' && item.civil_status === 'Total')[0].bilang}
        }

        const relationWithFamilyHead = {
          title: "Relasyon sa Puno ng Pamilya",
          genders: [
            {gender: {name: "Female"}, status: fetchedData[5].filter(item => item.sex === 'Female').map(item => (
              {name: item.relationship, count: item.bilang, percent: item.percent}
            ))},
            {gender: {name: "Male"}, status: fetchedData[5].filter(item => item.sex === 'Male').map(item => (
              {name: item.relationship, count: item.bilang, percent: item.percent}
            ))}
          ],
          summary: {name: "Total", count: fetchedData[5].filter(item => item.sex === 'Total')[0].bilang}
          
        }

        const ethnicInfo = {
          title: "Ethnic Group",
          genders: [
            {gender: {name: "Male"}, status: fetchedData[6].filter(item => item.sex === 'Male').map(item => (
              {name: item.ethnicity, count: item.bilang, percent: item.percent}
            ))},
            {gender: {name: "Female"}, status: fetchedData[6].filter(item => item.sex === 'Female').map(item => (
              {name: item.ethnicity, count: item.bilang, percent: item.percent}
            ))},
          ],
          summary: {name: "Total", count: fetchedData[6].filter(item => item.sex === 'Total')[0].bilang}
        }

        const citizenshipInfo = {
          title: "Citizenship",
          genders: [
            {gender: {name: "Male"}, status: fetchedData[7].filter(item => item.sex === 'Male').map(item => (
              {name: item.citizenship, count: item.bilang, percent: item.percent}
            ))},
            {gender: {name: "Female"}, status: fetchedData[7].filter(item => item.sex === 'Female').map(item => (
              {name: item.citizenship, count: item.bilang, percent: item.percent}
            ))},
          ],
          summary: {name: "Total", count: fetchedData[7].filter(item => item.sex === 'Total')[0].bilang}
        }

        const religionInfo = {
          title: "Relihiyon ng Miyembro ng Pamilya",
          genders: [
            {gender: {name: "Male"}, status: fetchedData[8].filter(item => item.sex === 'Male').map(item => (
              {name: item.religion, count: item.bilang, percent: item.percent}
            ))},
            {gender: {name: "Female"}, status: fetchedData[8].filter(item => item.sex === 'Female').map(item => (
              {name: item.religion, count: item.bilang, percent: item.percent}
            ))}
          ],
          summary: {name: "Total", count: fetchedData[8].filter(item => item.sex === 'Total')[0].bilang}
        }

        const organizationMembership = {
          title: "Membership sa mga Organisasyon",
          genders: [
            {gender: {name: "Female", count: ''}, status: fetchedData[9].filter(item => item.sex = 'Female').map((item, index) => {
              return (
                {name: item.organizations, count: item.bilang, percent: item.percent}
              )
            })},
            {gender: {name: "Male", count: ''}, status: fetchedData[9].filter(item => item.sex = 'Male').map((item, index) => {
              return (
                {name: item.organizations, count: item.bilang, percent: item.percent}
              )
            })}
          ],
          summary: {name: "Total", count: ''} 
        }

        const skillsInfo = {
          title: "Skills",
          genders: [
            {gender: {name: "Female", count: fetchedData[10].filter(item => item.sex === 'Female' && item.skill !== 'Total').bilang}, 
              status: fetchedData[10].filter(item => item.sex === 'Female').map(item => (
                {name: item.skill, count: item.bilang, percent: item.percent}
              ))
            },
            {gender: {name: "Male", count: fetchedData[10].filter(item => item.sex === 'Male' && item.skill !== 'Total').bilang}, 
              status: fetchedData[10].filter(item => item.sex === 'Male').map(item => (
                {name: item.skill, count: item.bilang, percent: item.percent}
              ))
            },
          ],
          summary: {name: "Total", count: fetchedData[10].filter(item => item.sex === 'Both Sex' && item.skill === 'Total')[0].bilang}
        }

        const tabulizeGeneralInfo = generalInfo.flatMap((info) => {
          const rows = [];

          // Add title row
          rows.push([
            { content: info.title.name, styles: {cellPadding: {top: 10, bottom: 3}}},
            { content: info.title.count ?? "" }
          ]);

          // Add division row (if any)
          if (info.division) {
            rows.push([
              { content: info.division.name, styles: {cellPadding: {left: 5}, fontStyle: "bolditalic"} },
            ]);
          }

          // Add categories (if any)
          if (info.categories) {
            const categoryRows = info.categories.map((category) => [
              { content: category.name, styles: {cellPadding: {left: 15}, fontStyle: category.name === "Kabuuan" ? "bold" : "normal"} },
              { content: category.count ?? "", styles: {fontStyle: category.name === "Kabuuan" ? "bold" : "normal"} },
              { content: category.percent ?? ""}
            ]);
            rows.push(...categoryRows);
          }

          return rows;
        });

        const generalInfoBody = [
          ...tabulizeGeneralInfo, // spread into array
        ];

        const migrationInfoBody = [
          [{content: migrationInfo.title, styles: {cellPadding: {top: 10}}}],
          ...migrationInfo.status.map((status) => {
            return [
              {content: status.name, styles: {cellPadding: {left: 10, top: 5, bottom: 5}}}, 
              {content: status.count}, 
              {content: status.percent}
            ];
          }),
          [
            {content: migrationInfo.summary.name, styles: {fontStyle: "bold", cellPadding: {top: 10, bottom: 5}, halign: "center"}},
            {content: migrationInfo.summary.count, styles: {fontStyle: "bold", cellPadding: {top: 10, bottom: 5}}},
            {content: migrationInfo.summary.percent, styles: {fontStyle: "bold", cellPadding: {top: 10, bottom: 5}}}
          ],
          [{content: durationOfStay.title, colSpan: 3, styles: {cellPadding: {top: 5}, lineWidth: {top: 4}, lineColor: GRAY}}],
          [
            {content: durationOfStay.header.head1, styles: {cellPadding: {left: 80, top: 5}}},
            {content: durationOfStay.header.head2, styles: {cellPadding: {bottom: 5, top: 5}}},
            {content: durationOfStay.header.head3, styles: {cellPadding: {bottom: 5, top: 5}}}
          ],
          ...durationOfStay.categories.map((category) => {
            return [
              {content: category.name, styles: {cellPadding: {left: 80, top: 10}}},
              {content: category.frequency, styles: {cellPadding: {top: 10}}},
              {content: category.percentage, styles: {cellPadding: {top: 10}}}
            ]
          }),
          [
            {content: durationOfStay.summary.name, styles: {fontStyle: "bolditalic", cellPadding: {top: 10}, halign: "center"}},
            {content: durationOfStay.summary.average, styles: {fontStyle: "bolditalic", cellPadding: {top: 10}}},
          ],
        ];

        const otherInfo = [
          kalagayangSibil,
          familyHeadWithJobs,
          relationWithFamilyHead,
          ethnicInfo,
          citizenshipInfo,
          religionInfo,
          organizationMembership,
          skillsInfo
        ]

        const createInfoBody = (info) =>  {
            const rows = [];

            // Add title row
            rows.push([{content: info.title}]);

            // Add header row (optional)
            if (info.headers) {
              rows.push(
                [
                  {content: info.headers.head1, styles: {cellPadding: {left: 20, top: 10}, fontStyle: "bold"}},
                  {content: info.headers.head2, styles: {cellPadding: {top: 10}, fontStyle: "bold"}}
                ]
              )
            }

            // Add details row
            rows.push(
              ...info.genders.flatMap((gender) => {
                const detailsRow = [];

                detailsRow.push([
                  {content: gender.gender.name, styles: {fontStyle: "bold", cellPadding: {left: 20, top: 5, bottom: 5}}},
                  {content: gender.gender.count ?? "", styles: {fontStyle: "bold", cellPadding: {top: 5, bottom: 5}}}
                ]);

                detailsRow.push(
                  ...gender.status.map((sta) => {
                    return [
                      {content: sta.name, styles: {cellPadding: {left: 20, top: 3, bottom: 3}}},
                      {content: sta.count, styles: {cellPadding: {top: 3, bottom: 3}}},
                      {content: sta.percent, styles: {cellPadding: {top: 3, bottom: 3}}}
                    ]
                  })
                )

                return detailsRow;
              })
            )
            
            rows.push([
              {content: info.summary.name, styles: {fontStyle: "bold", cellPadding: {left: 80, top: 10}}},
              {content: info.summary.count, styles: {fontStyle: "bold", cellPadding: {top: 10}}}
            ])
            

            return rows;
        }
          
        const contentWidth = pageWidth - padding * 2;

        // GENERAL INFO TABLE
        autoTable(doc, {
          startY: 110,
          head: head,
          body: generalInfoBody,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2,
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // Percent
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 6,
                left: 0,
              };
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(
              padding,
              pageHeight - padding - 10,
              pageWidth - padding,
              pageHeight - padding - 10
            );
          },
        });

        // PAGE BREAK
        doc.addPage();

        // MIGRATION AND DURATION OF STAY TABLE
        autoTable(doc, {
          startY: padding,
          head: head,
          body: migrationInfoBody,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2,
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // Percent
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 6,
                left: 0,
              };
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(
              padding,
              pageHeight - padding - 10,
              pageWidth - padding,
              pageHeight - padding - 10
            );
          },
        });

        for (const info of otherInfo) {
          const bodyInfo = createInfoBody(info);

          // PAGE BREAK
          doc.addPage();

          // INFO TABLE
          autoTable(doc, {
            startY: padding,
            head: head,
            body: bodyInfo,
            theme: "grid",
            showHead: "firstPage",
            margin: {
              left: padding,
              right: pageWidth - padding,
              bottom: padding + 20,
            },
            styles: {
              fontSize: 10,
              cellPadding: {
                left: 0,
                top: 2,
                bottom: 2,
              },
              overflow: "linebreak",
              lineWidth: 0,
              lineColor: [0, 0, 0],
              textColor: [0, 0, 0],
            },
            headStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              halign: "center",
              valign: "center",
              lineColor: [0, 0, 0],
              fontSize: 10,
            },
            columnStyles: {
              0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
              1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
              2: { cellWidth: contentWidth * 0.2, halign: "center" }, // Percent
            },
            didParseCell: function (data) {
              if (data.section === "head" && data.row.index === 0) {
                data.cell.styles.lineColor = GRAY;
                data.cell.styles.lineWidth = {
                  top: 3,
                  right: 0,
                  bottom: 6,
                  left: 0,
                };
                data.cell.styles.cellPadding = {
                  top: 0,
                  right: 4,
                  bottom: 10,
                  left: 8,
                };
              }
            },
            didDrawPage: function (data) {
              doc.setLineWidth(3);
              doc.setDrawColor(211, 211, 211);
              doc.line(
                padding,
                pageHeight - padding - 10,
                pageWidth - padding,
                pageHeight - padding - 10
              );
            },
          });
        }

      } else if (formName === "[3b] Demographic data by purok (Population, No. of Houses and Families, Religion, Organization, Civil Status, Relation to HH)") {
        const title = 'Table 4. Kaanyuan ng Pamilya bawat Purok';
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const head = [
          ["Kaanyuan", "Bilang", "%"]
        ];

        const parseData = () => {
          if (Object.keys(fetchedData).length === 0) return [
            {
              purok: `Purok __`,
              details: [
                { name: "Populasyon", count: 0 },
                { name: "Kabuuang bilang ng bahay", count: 0 },
                {
                  name: "Kasarian ng Puno ng Pamilya", genders: [
                    { name: "Babae", count: 0, percent: 0 },
                    { name: "Lalake", count: 0, percent: 0  },
                    { name: "Kabuuan", count: 0, percent: "" }
                  ]
                }, 
                { name: "Pangkaraniwang bilang ng miyembro kada pamilya (average family size)", count: 0 }
              ]
            }
          ]
          return fetchedData.map((item, index) => {
            const male_percent = Math.round((Number(item.male) / (Number(item.male) + Number(item.female))) * 100) + "%";
            const female_percent = Math.round((Number(item.female) / (Number(item.male) + Number(item.female))) * 100) + "%";
            const kabuuan = Number(item.male) + Number(item.female);
            return ({
              purok: `Purok ${item.purok}`,
              details: [
                { name: "Populasyon", count: item.populasyon },
                { name: "Kabuuang bilang ng bahay", count: item.kabuuang_bahay },
                {
                  name: "Kasarian ng Puno ng Pamilya", genders: [
                    { name: "Babae", count: item.male, percent: male_percent },
                    { name: "Lalake", count: item.female, percent: female_percent  },
                    { name: "Kabuuan", count: kabuuan, percent: "" }
                  ]
                },
                { name: "Pangkaraniwang bilang ng miyembro kada pamilya (average family size)", count: item.average_family_size }
              ]
            })
          })
        }

        const data = [
          ...parseData()
        ];

        const sampleBody = data.flatMap((item, itemIndex) => {
          const rows = [];

          // Purok title row
          rows.push([
            { content: item.purok, colSpan: 3, styles: { fontStyle: "bolditalic", fontSize: 12, cellPadding: { bottom: 10, top: 10 } } },
          ]);

          // Details
          item.details.forEach((detail, index) => {
            const lastDetail = index === item.details.length - 1;
            const lastItem = itemIndex === data.length - 1;
            if (detail.genders) {
              // Main category row
              rows.push([{ content: detail.name, styles: {cellPadding: {left: 20}} }, { content: "" }, { content: "" }]);
              // Gender sub-rows
              detail.genders.forEach((gender) => {
                rows.push([
                  { content: gender.name, styles: {cellPadding: {left: gender.name === "Kabuuan" ? 80 : 40}, fontStyle: gender.name === "Kabuuan" ? "bold" : "normal"} },
                  { content: gender.count, styles: {fontStyle: gender.name === "Kabuuan" ? "bold" : "normal"} },
                  { content: gender.percent, styles: {fontStyle: gender.name === "Kabuuan" ? "bold" : "normal"} }
                ]);
              });
            } else {
              rows.push([
                { content: detail.name, styles: {cellPadding: {left: 20, bottom: lastDetail && lastItem ? 5 : lastDetail ? 5 : 0}, lineWidth: {bottom: lastDetail && lastItem ? 1 : lastDetail ? 2 : 0}, lineColor: BLUE}  },
                { content: detail.count ?? "", styles: {lineWidth: {bottom: lastDetail && lastItem ? 1 : lastDetail? 2 : 0}, lineColor: BLUE, cellPadding: {bottom: lastDetail && lastItem ? 5 : lastDetail ? 5 : 0}} },
                { content: "", styles: {lineWidth: {bottom: lastDetail && lastItem ? 1 : lastDetail ? 2 : 0, cellPadding: {bottom: lastDetail && lastItem ? 5 : lastDetail ? 5 : 0}}, lineColor: BLUE} }
              ]);
            }
          });

          return rows;
        });


        const contentWidth = pageWidth - padding * 2;

        autoTable(doc, {
            startY: 100,
            head: head,
            body: sampleBody,
            theme: "grid",
            showHead: "firstPage",
            margin: {
              left: padding,
              right: pageWidth - padding,
              bottom: padding + 20,
            },
            styles: {
              fontSize: 10,
              cellPadding: {
                left: 0,
                top: 2,
                bottom: 2,
              },
              overflow: "linebreak",
              lineWidth: 0,
              lineColor: [0, 0, 0],
              textColor: [0, 0, 0],
            },
            headStyles: {
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
              halign: "center",
              valign: "center",
              lineColor: [0, 0, 0],
              fontSize: 10,
            },
            columnStyles: {
              0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
              1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
              2: { cellWidth: contentWidth * 0.2, halign: "center" }, // Percent
            },
            didParseCell: function (data) {
              if (data.section === "head" && data.row.index === 0) {
                data.cell.styles.lineColor = GRAY;
                data.cell.styles.lineWidth = {
                  top: 3,
                  right: 0,
                  bottom: 6,
                  left: 0,
                };
                data.cell.styles.cellPadding = {
                  top: 0,
                  right: 4,
                  bottom: 10,
                  left: 8,
                };
              }
            },
            didDrawPage: function (data) {
              doc.setLineWidth(3);
              doc.setDrawColor(211, 211, 211);
              doc.line(
                padding,
                pageHeight - padding - 10,
                pageWidth - padding,
                pageHeight - padding - 10
              );
            },
          });
      } else if (formName === "[4a] Antas ng pinag-aralan ng barangay") {
        const title = 'Table 5. Antas ng pinag-aralan sa barangay';
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const head = [
          [
            "Antas ng Pinag-aralan",
            "Bilang",
            "%"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 20, top: 10, bottom: 20}, halign: "left"}, colSpan: 3}]
        ]

        const dataByLevel = (fetchedData) => {
          return fetchedData.length < 2 ? [] : fetchedData.slice(2,6).map((item, index) => {
            return (
              {antas: item.antas,
                status: [
                  {name: "Undergraduate (Hindi nakatapos)", count: item.hindi_nakatapos, percent: item.hindi_nakatapos_percent},
                  {name: "Graduate (Nakatapos)", count: item.nagaaral_pa, percent: item.nagaaral_pa_percent}
                ]
              }
            )
          })
        }

        const dataByGrade = (fetchedData) => {
          return fetchedData.length < 6 ? [] : fetchedData.slice(6,-1).map((item, index) => {
            return (
              {antas: item.antas,
                status: [
                  item.hindi_nakatapos ? {name: "Undergraduate (Hindi nakatapos)", count: item.hindi_nakatapos, percent: item.hindi_nakatapos_percent} : null,
                  item.nagaaral_pa ? {name: "Still Studying (Nag-aaral pa)", count: item.nagaaral_pa, percent: item.nagaaral_pa_percent} : null
                ]
              }
            )
          })
        }

        const data = [
          {
            antas: "Hindi pa Nag-aaral", 
            count: fetchedData[1][0].bilang, 
            percent: fetchedData[1][0].percent
          },
          {
            antas: "Hindi nakapag-aral", 
            count: fetchedData[1][1].bilang, 
            percent: fetchedData[1][1].percent
          },
          ...dataByLevel(fetchedData[0])
          ,
          ...dataByGrade(fetchedData[0]),
          fetchedData[0].length !== 1 ? {antas: 'Barangay Kabuuan', count: fetchedData[0][fetchedData[0].length - 1].bilang, percent: fetchedData[0][fetchedData[0].length - 1].nagaaral_pa_percent} : 
          {antas: 'Barangay Kabuuan', count: 0, percent: 0}
        ]

        const body = [
          ...data.flatMap((item, index) => {
            const rows = [];
            const lastItem = index === data.length - 1;

            rows.push([
              {content: item.antas, styles: {cellPadding: {left: 20, bottom: lastItem ? 10 : 0}, fontStyle: lastItem ? "bold" : "normal", lineWidth: {bottom: lastItem ? 3 : 0}, lineColor: BLUE}},
              {content: item.count ?? "", styles: {fontStyle: lastItem ? "bold" : "normal", cellPadding: {bottom: lastItem ? 10 : 0}, lineWidth: {bottom: lastItem ? 3 : 0}, lineColor: BLUE}},
              {content: item.percent ?? "", styles: {fontStyle: lastItem ? "bold" : "normal", cellPadding: {bottom: lastItem ? 10 : 0}, lineWidth: {bottom: lastItem ? 3 : 0}, lineColor: BLUE}}
            ]);

            if (item.status) {
              item.status.forEach((sta) => {
                if (sta != null) {
                  rows.push([
                  {content: sta.name, styles: {cellPadding: {left: 40}}},
                  {content: sta.count},
                  {content: sta.percent}
                ])
                }
              })
            }

            return rows;
          })
        ]

        const contentWidth = pageWidth - padding * 2;
        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2,
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // Percent
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = BLUE;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 6,
                left: 0,
              };
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(
              padding,
              pageHeight - padding - 10,
              pageWidth - padding,
              pageHeight - padding - 10
            );
          },
        });

      } else if (formName === '[4b] Antas ng pinag-aralan ng barangay ayon sa kasarian') {
        const title = 'Table 5. Antas ng pinag-aralan sa barangay';
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const head = [
          [
            {content: "Antas ng Pinag-aralan"},
            {content: "Bilang", colSpan: 2},
            {content: "", colSpan: 2}
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 20, top: 10, bottom: 20}, halign: "left"}, colSpan: 3}]
        ]

        const hpna_info = fetchedData[1][0];
        const hna_info = fetchedData[1][1];

        const generalInfo = 
          {
            header: ["Male", "Female"],
            detail: [
              {
                name: "Hindi pa Nag-aaral", 
                m_count: hpna_info.male, 
                f_count: hpna_info.female, 
                total: hpna_info.total, 
                percent: hpna_info.percent
              },
              {
                name: "Hindi nakapag-aral", 
                m_count: hna_info.male, 
                f_count: hna_info.female, 
                total: hna_info.total, 
                percent: hna_info.percent
              },
            ]
          }
        

        const data = fetchedData[0].length !== 1 ? [
          {
            gender: 'Female',
            details: [
              ...fetchedData[0].slice(2,6).map((item, index) => {
                return (
                  {antas: item.antas,
                    status: [
                      {name: "Undergraduate (Hindi nakatapos)", count: item.fhn, percent: `${item.fhmnp}%`},
                      {name: "Graduate (Nakatapos)", count: item.fnp, percent: `${item.fnpp}%`}
                    ]
                  }
                )
              }),
              ...fetchedData[0].slice(6,-1).map((item, index) => {
                return (
                  {antas: item.antas,
                    status: [
                      item.fhn ? {name: "Undergraduate (Hindi nakatapos)", count: item.fhn, percent: `${item.fhmnp}%`} : null,
                      item.fnp ? {name: "Still Studying (Nag-aaral pa)", count: item.fnp, percent: `${item.fnpp}%`} : null
                    ]
                  }
                )
              }),
            ]
          },
          {
            gender: 'Male',
            details: [
              ...fetchedData[0].slice(2,6).map((item, index) => {
                return (
                  {antas: item.antas,
                    status: [
                      {name: "Undergraduate (Hindi nakatapos)", count: item.mhn, percent: `${item.mhnp}%`},
                      {name: "Graduate (Nakatapos)", count: item.mnp, percent: `${item.mnpp}%`}
                    ]
                  }
                )
              }),
              ...fetchedData[0].slice(6,-1).map((item, index) => {
                return (
                  {antas: item.antas,
                    status: [
                      item.mhn ? {name: "Undergraduate (Hindi nakatapos)", count: item.mhn, percent: `${item.mhnp}%`} : null,
                      item.mnp ? {name: "Still Studying (Nag-aaral pa)", count: item.mnp, percent: `${item.mnpp}%`} : null
                    ]
                  }
                )
              }),
            ]
          }
        ] : []

        const sampleBody = [
          [
            {content: ""},
            {content: generalInfo.header[0], styles: {fontStyle: "bolditalic"}},
            {content: generalInfo.header[1], styles: {fontStyle: "bolditalic"}}
          ],
          ...generalInfo.detail.map((item, index) => {
            const lastItem = index === generalInfo.detail.length - 1;
            return [
              {content: item.name, styles: {cellPadding: {left: 20, bottom: lastItem ? 10 : 3}}},
              {content: item.m_count, styles: {cellPadding: {bottom: lastItem ? 10 : 3}}},
              {content: item.f_count, styles: {cellPadding: {bottom: lastItem ? 10 : 3}}},
              {content: item.total, styles: {cellPadding: {bottom: lastItem ? 10 : 3}}},
              {content: item.percent, styles: {cellPadding: {bottom: lastItem ? 10 : 3}}}
            ]
          }),
          ...data.flatMap((item, index) => {
            const rows = [];

            rows.push([
              {content: item.gender, colSpan: 5, styles: {fontStyle: "bold", fillColor: GRAY, cellPadding: {left: 2, top: 5, bottom: 5}}}
            ])

            item.details.forEach((detail) => {
              rows.push([
                {content: detail.antas, styles: {cellPadding: {left: 20}}}
              ])

              detail.status.forEach((sta, index) => {
                const lastStatus = index === detail.status.length - 1; 
                if (sta != null) {
                  rows.push([
                    {content: sta.name, styles: {cellPadding: {left: 40, bottom: lastStatus ? 10 : 5}}},
                    {content: sta.count, colSpan: 2, styles: {cellPadding: {bottom: lastStatus ? 10 : 5}}},
                    {content: sta.percent, colSpan: 2, styles: {cellPadding: {bottom: lastStatus ? 10 : 5}}}
                  ])
                }
              })
            })

            return rows;
          }),
          [
            {content: "Barangay Kabuuan", styles: {fontStyle: "bolditalic", cellPadding: {left: 20}}}, 
            {content: fetchedData[0].length !== 1 ? fetchedData[0][fetchedData[0].length - 1].male : 0, colSpan: 2, styles: {fontStyle: "bold"}}, 
            {content: fetchedData[0].length !== 1 ? 100.00 : 0, colSpan: 2, styles: {fontStyle: "bold"}}
          ]
        ]

        const contentWidth = pageWidth - padding * 2;
        autoTable(doc, {
          startY: 100,
          head: head,
          body: sampleBody,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2,
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.1, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.1, halign: "center" }, // Percent
            3: { cellWidth: contentWidth * 0.1, halign: "center" }, // Bilang
            4: { cellWidth: contentWidth * 0.1, halign: "center" }, // Percent
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = BLUE;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 6,
                left: 0,
              };
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(
              padding,
              pageHeight - padding - 10,
              pageWidth - padding,
              pageHeight - padding - 10
            );
          },
        });

      } else if (formName === "[5] Uri ng paaralan na pinapasukan ng mga mag-aaral") {
        const title = 'Table 6. Uri ng paaralan na pinapasukan ng mga kabataan';
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const head = [
          [
            "Uri",
            "Bilang",
            "%"
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 20, top: 10, bottom: 20}, halign: "left"}, colSpan: 3}]
        ]

        const data = fetchedData.map((item, index) => (
          {
            name: item.school,
            count: item.bilang,
            percent: item.percent
          }
        ))

        const kabuuan_bilang = data.reduce((total, item) => Number(total) + Number(item.count), 0);

        const body = [
          ...data.flatMap((item, index) => {
            const rows = [];

            rows.push([
              {content: item.name, styles: {cellPadding: {left: 20}}},
              {content: item.count},
              {content: item.percent}
            ])

            return rows;
          }),
          [
            {content: "Kabuuan:", styles: {lineWidth: {bottom: 2}, lineColor: BLUE, fontStyle: "bolditalic", cellPadding: {left: 20, bottom: 10}}},
            {content: kabuuan_bilang, styles: {lineWidth: {bottom: 2}, lineColor: BLUE, fontStyle: "bold", cellPadding: {bottom: 10}}},
            {content: 100.00, styles: {lineWidth: {bottom: 2}, lineColor: BLUE, fontStyle: "bold", cellPadding: {bottom: 10}}},
          ]
        ]

        const contentWidth = pageWidth - padding * 2;
        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2,
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // Percent
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = BLUE;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 6,
                left: 0,
              };
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(
              padding,
              pageHeight - padding - 10,
              pageWidth - padding,
              pageHeight - padding - 10
            );
          },
        });
      } else if (formName === "[6] Out of School Youth") {
        const title = 'Table 7. Out of School Youth';
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const head = [
          [
            {content: "Uri",},
            {content: "Bilang", colSpan: 2},
            {content: "Bilang", colSpan: 2},
            {content: "Total", colSpan: 2}
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 20, top: 10, bottom: 20}, halign: "left"}, colSpan: 7}]
        ]

        const data = 
          {headers: ["Male", "Female", "Total"], 
            antas: fetchedData.slice(0, fetchedData.length - 1).map((item, index) => (
              {name: item.antas, m_count: item.bilang_male, m_percent: `${item.male_percent}%`, f_count: item.bilang_female, f_percent: `${item.female_percent}%`, total_count: item.total, total_percent: item.total_percent}
            )),
            summary: {
              name: "Barangay Kabuuan:", 
              m_count: fetchedData[fetchedData.length - 1].bilang_male, 
              m_percent: `${fetchedData[fetchedData.length - 1].male_percent}%`, 
              f_count: fetchedData[fetchedData.length - 1].bilang_female, 
              f_percent: `${fetchedData[fetchedData.length - 1].female_percent}%`, 
              total_count: fetchedData[fetchedData.length - 1].total, 
              total_percent: fetchedData[fetchedData.length - 1].total_percent
            },
          }
        

        const body = [
          [
            {content: ""},
            {content: data.headers[0], colSpan: 2, styles: {fontStyle: "bold"}},
            {content: data.headers[1], colSpan: 2, styles: {fontStyle: "bold"}},
            {content: data.headers[2], colSpan: 2, styles: {fontStyle: "bold"}}
          ],
          ...data.antas.flatMap((item, index) => {
            const rows = [];
            
            rows.push([
              {content: item.name, styles: {cellPadding: {left: 10}}},
              {content: item.m_count},
              {content: item.m_percent},
              {content: item.f_count},
              {content: item.f_percent},
              {content: item.total_count},
              {content: item.total_percent},
            ])

            return rows;
          }),
          [
            {content: data.summary.name, styles: {lineWidth: {bottom: 2}, lineColor: BLUE, fontStyle: "bolditalic", cellPadding: {left: 10, bottom: 10, top: 15}}},
            {content: data.summary.m_count, styles: {lineWidth: {bottom: 2}, lineColor: BLUE, fontStyle: "bold", cellPadding: {bottom: 10, top: 15}}},
            {content: data.summary.m_percent, styles: {lineWidth: {bottom: 2}, lineColor: BLUE, fontStyle: "bold", cellPadding: {bottom: 10, top: 15}}},
            {content: data.summary.f_count, styles: {lineWidth: {bottom: 2}, lineColor: BLUE, fontStyle: "bold", cellPadding: {bottom: 10, top: 15}}},
            {content: data.summary.f_percent, styles: {lineWidth: {bottom: 2}, lineColor: BLUE, fontStyle: "bold", cellPadding: {bottom: 10, top: 15}}},
            {content: data.summary.total_count, styles: {lineWidth: {bottom: 2}, lineColor: BLUE, fontStyle: "bold", cellPadding: {bottom: 10, top: 15}}},
            {content: data.summary.total_percent, styles: {lineWidth: {bottom: 2}, lineColor: BLUE, fontStyle: "bold", cellPadding: {bottom: 10, top: 15}}},
          ]
        ]

        const contentWidth = pageWidth - padding * 2;
        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2,
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.4, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.1, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.1, halign: "center" }, // Bilang
            3: { cellWidth: contentWidth * 0.1, halign: "center" }, // Bilang
            4: { cellWidth: contentWidth * 0.1, halign: "center" }, // Bilang
            5: { cellWidth: contentWidth * 0.1, halign: "center" }, // Total
            6: { cellWidth: contentWidth * 0.1, halign: "center" }, // Total
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = BLUE;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 6,
                left: 0,
              };
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(
              padding,
              pageHeight - padding - 10,
              pageWidth - padding,
              pageHeight - padding - 10
            );
          },
        });
      } else if (formName === "[7] Mga Nagtatrabaho sa Barangay Ayon sa Edad at Kasarian") {
        const title = "Table 8. Mga nagtatrabaho sa barangay ayon sa edad";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding + 10,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10, 85, { align: "left" });

        // headers
        const head = [
          [
            "",
            {content: "Lalake", colSpan: 2},
            {content: "Babae", colSpan: 2},
            {content: "Kabuuan", colSpan: 2},
          ],
          [
            {content: "Edad"}, 
            {content: "Bilang"}, 
            {content: "%"}, 
            {content: "Bilang"},
            {content: "%"},
            {content: "Bilang"},
            {content: "%"},
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 0, top: 10, bottom: 10}, halign: "left"}, colSpan: 4}]
        ]

        const data = [
          ...fetchedData.map((item, index) => (
            {
              age: item.age_range, 
              lalake_bilang: item.lalake_bilang, 
              lalake_percent: item.lalake_percent, 
              babae_bilang: item.babae_bilang,
              babae_percent: item.babae_percent, 
              kabuuan_bilang: item.kabuuan_bilang, 
              kabuuan_percent: item.kabuuan_percent
            }
          ))
        ];

        const body = [
          ...data.map((item, index) => {
            const lastItem = index === data.length - 1;
            return [
              {content: item.age, styles: {lineWidth: {bottom: lastItem ? 3 : 0}, lineColor: BLUE, fontStyle: "bold", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 5}}},
              {content: item.lalake_bilang, styles: {lineWidth: {bottom: lastItem ? 3 : 0}, lineColor: BLUE, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 5}}},
              {content: item.lalake_percent, styles: {lineWidth: {bottom: lastItem ? 3 : 0}, lineColor: BLUE, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 5}}},
              {content: item.babae_bilang, styles: {lineWidth: {bottom: lastItem ? 3 : 0}, lineColor: BLUE, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 5}}},
              {content: item.babae_percent, styles: {lineWidth: {bottom: lastItem ? 3 : 0}, lineColor: BLUE, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 5}}},
              {content: item.kabuuan_bilang, styles: {lineWidth: {bottom: lastItem ? 3 : 0}, lineColor: BLUE, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 5}}},
              {content: item.kabuuan_percent, styles: {lineWidth: {bottom: lastItem ? 3 : 0}, lineColor: BLUE, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 5}}},
            ]
          })
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.25, halign: "center", styles: {fontStyle: "bold"} }, // edad
            1: { cellWidth: contentWidth * 0.125, halign: "center" }, // bilang ng lalaki
            2: { cellWidth: contentWidth * 0.125, halign: "center" }, // percent ng lalaki
            3: { cellWidth: contentWidth * 0.125, halign: "center" }, // bilang ng babae
            4: { cellWidth: contentWidth * 0.125, halign: "center" }, // percent ng babae
            5: { cellWidth: contentWidth * 0.125, halign: "center" }, // bilang ng kabuuan
            6: { cellWidth: contentWidth * 0.125, halign: "center" }, // percent ng kabuuan
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 4,
                right: 0,
                bottom: 0,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 3,
                right: 0,
                bottom: 3,
                left: 0,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 5,
                right: 0,
                bottom: 14,
                left: 0,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[8] Uri at Kalagayan ng Hanapbuhay ng Puno ng Pamilya at Asawa") {
        const title = "Table 9. Uri at Kalagayan ng Hanapbuhay ng Puno ng Pamilya at Asawa\nng Barangay";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding + 10,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10, 100, { align: "left" });

        // headers
        const head = [
          [
            {content: "Kalagayan"},
            {content: "Puno/Extension", colSpan: 2},
            {content: "Asawa", colSpan: 2},
            {content: "Kabuuan", colSpan: 2},
          ],
          [
            {content: ""}, 
            {content: "Bilang"}, 
            {content: "%"}, 
            {content: "Bilang"},
            {content: "%"},
            {content: "Bilang"},
            {content: "%"},
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 10, top: 10, bottom: 10}, halign: "left"}, colSpan: 4}]
        ]

        const generalData = fetchedData[0].length !== 0 ? [
          ...fetchedData[0].map((item, index) => (
            {
              status: item.class, 
              lalake_bilang: item.puno_extension_bilang, 
              lalake_percent: item.puno_extension_percentage, 
              babae_bilang: item.asawa_bilang, 
              babae_percent: item.asawa_percentage, 
              kabuuan_bilang: item.kabuuan_bilang, 
              kabuuan_percent: item.kabuuan_percentage
            }
          ))
        ] : [];

        const specificData = fetchedData[1].length !== 0 ? [
          ...fetchedData[1].slice(0, fetchedData[1].length - 1).map((item, index) => ({
                name: item.job, 
                lalake_bilang: item.puno_extension_bilang, 
                lalake_percent: item.puno_extension_percent, 
                babae_bilang: item.asawa_bilang, 
                babae_percent: item.asawa_percent, 
                kabuuan_bilang: item.kabuuan_bilang, 
                kabuuan_percent: item.kabuuan_percent
              })),
        ] : [];

        const body = [
          [{content: "Kalagayan ng Hanapbuhay", colSpan: 7, styles: {fontStyle: "bold", cellPadding: {left: 5, top: 10}}}],
          ...generalData.flatMap((item, index) => {
            const rows = [];
            const lastItem = index === generalData.length - 1;
            rows.push([
              {content: item.status, styles: {lineWidth: {bottom: lastItem ? 1.5 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold" : "normal", cellPadding: {left: 10, top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: item.lalake_bilang, styles: {lineWidth: {bottom: lastItem ? 1.5 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: item.lalake_percent, styles: {lineWidth: {bottom: lastItem ? 1.5 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: item.babae_bilang, styles: {lineWidth: {bottom: lastItem ? 1.5 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: item.babae_percent, styles: {lineWidth: {bottom: lastItem ? 1.5 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: item.kabuuan_bilang, styles: {lineWidth: {bottom: lastItem ? 1.5 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: item.kabuuan_percent, styles: {lineWidth: {bottom: lastItem ? 1.5 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
            ]);

            if (item.subStatus) {
              for (const ss of item.subStatus) {
                rows.push(
                  [
                    {content: ss.status, styles: {cellPadding: {left: 20, top: 5}}},
                    {content: ss.lalake_bilang, styles: {cellPadding: {top: 5}}},
                    {content: ss.lalake_percent, styles: {cellPadding: {top: 5}}},
                    {content: ss.babae_bilang, styles: {cellPadding: {top: 5}}},
                    {content: ss.babae_percent, styles: {cellPadding: {top: 5}}},
                    {content: ss.kabuuan_bilang, styles: {cellPadding: {top: 5}}},
                    {content: ss.kabuuan_percent, styles: {cellPadding: {top: 5}}},
                  ]
                )
              }
            }

            return rows;
          }),
          ...specificData.flatMap((job, index) => {
            const rows = [];
            const lastItem = index === generalData.length - 1;

            rows.push([
              {content: job.name, styles: {cellPadding: {left: 10, top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: job.lalake_bilang, styles: {cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: job.lalake_percent, styles: {cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: job.babae_bilang, styles: {cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: job.babae_percent, styles: {cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: job.kabuuan_bilang, styles: {cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: job.kabuuan_percent, styles: {cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
            ])
            
 
            return rows;
          }),
          [
            {content: fetchedData[1][fetchedData[1].length - 1].category, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
            {content: fetchedData[1][fetchedData[1].length - 1].puno_extension_bilang, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
            {content: fetchedData[1][fetchedData[1].length - 1].puno_extension_percent, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
            {content: fetchedData[1][fetchedData[1].length - 1].asawa_bilang, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
            {content: fetchedData[1][fetchedData[1].length - 1].asawa_percent, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
            {content: fetchedData[1][fetchedData[1].length - 1].kabuuan_bilang, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
            {content: fetchedData[1][fetchedData[1].length - 1].kabuuan_percent,styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
          ]
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 110,
          head: head,
          body: body,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.4, halign: "left", styles: {fontStyle: "bold"} }, // edad
            1: { cellWidth: contentWidth * 0.1, halign: "center" }, // bilang ng lalaki
            2: { cellWidth: contentWidth * 0.1, halign: "center" }, // percent ng lalaki
            3: { cellWidth: contentWidth * 0.1, halign: "center" }, // bilang ng babae
            4: { cellWidth: contentWidth * 0.1, halign: "center" }, // percent ng babae
            5: { cellWidth: contentWidth * 0.1, halign: "center" }, // bilang ng kabuuan
            6: { cellWidth: contentWidth * 0.1, halign: "center" }, // percent ng kabuuan
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 4,
                right: 0,
                bottom: 0,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 3,
                right: 0,
                bottom: 7,
                left: 0,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 3,
                right: 0,
                bottom: 14,
                left: 0,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[9] Pinagkakakitaan ng Mamamayan ayon sa Kasarian") {
        const title = "Table 10. Mga Pinagkakakitaan ng Mamamayan ng Barangay ayon sa Major\nClassification ng Hanapbuhay";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding + 10,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 10, 100, { align: "left" });

        // headers
        const head = [
          [
            {content: "Pinagkakakitaan"},
            {content: "Lalake", colSpan: 2},
            {content: "Babae", colSpan: 2},
            {content: "KABUUAN", colSpan: 2},
          ],
          [
            {content: ""}, 
            {content: "Bilang"}, 
            {content: "%"}, 
            {content: "Bilang"},
            {content: "%"},
            {content: "Bilang"},
            {content: "%"},
          ],
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 10, top: 10, bottom: 10}, halign: "left"}, colSpan: 4}]
        ]

        const parseData = () => {
          const items = [];
          let prev_category = ''
          let jobs = [];
          for (let item of fetchedData.slice(0, fetchedData.length-1)) {
            if (prev_category === '') {
              prev_category = item.category;
              jobs.push({
                name: item.job, 
                lalake_bilang: item.male_bilang,
                lalake_percent: item.male_percent, 
                babae_bilang: item.female_bilang, 
                babae_percent: item.female_percent, 
                kabuuan_bilang: item.kabuuan_bilang, 
                kabuuan_percent: item.kabuuan_percent
              })
            } else if (item.category === prev_category) {
              jobs.push({
                name: item.job, 
                lalake_bilang: item.male_bilang,
                lalake_percent: item.male_percent, 
                babae_bilang: item.female_bilang, 
                babae_percent: item.female_percent, 
                kabuuan_bilang: item.kabuuan_bilang, 
                kabuuan_percent: item.kabuuan_percent
              })
            } else {
              items.push({
                category: prev_category,
                jobs: jobs
              });
              prev_category = item.category
              jobs = [
                {
                  name: item.job, 
                  lalake_bilang: item.male_bilang,
                  lalake_percent: item.male_percent, 
                  babae_bilang: item.female_bilang, 
                  babae_percent: item.female_percent, 
                  kabuuan_bilang: item.kabuuan_bilang, 
                  kabuuan_percent: item.kabuuan_percent
                }
              ]
            }
          }

          return items;
        }

        const data = [
          ...parseData()
        ]

        const body = [
          ...data.flatMap((item, index) => {
            const rows = [];

            rows.push([
              {content: item.category, colSpan: 7, styles: {fontStyle: "bold", cellPadding: {left: 5, top: 10, bottom: 15}}},
            ])

            for (const job of item.jobs) {
              rows.push([
                {content: job.name, styles: {cellPadding: {left: 10, top: 3, bottom: 3}}},
                {content: job.lalake_bilang, styles: {cellPadding: {top: 3, bottom: 3}}},
                {content: job.lalake_percent, styles: {cellPadding: {top: 3, bottom: 3}}},
                {content: job.babae_bilang, styles: {cellPadding: {top: 3, bottom: 3}}},
                {content: job.babae_percent, styles: {cellPadding: {top: 3, bottom: 3}}},
                {content: job.kabuuan_bilang, styles: {cellPadding: {top: 3, bottom: 3}}},
                {content: job.kabuuan_percent, styles: {cellPadding: {top: 3, bottom: 3}}},
              ])
            }
 
            return rows;
          }),
          [
            {content: fetchedData[fetchedData.length - 1].category, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
            {content: fetchedData[fetchedData.length - 1].male_bilang, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
            {content: fetchedData[fetchedData.length - 1].male_percent, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
            {content: fetchedData[fetchedData.length - 1].female_bilang, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
            {content: fetchedData[fetchedData.length - 1].female_percent, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
            {content: fetchedData[fetchedData.length - 1].kabuuan_bilang, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
            {content: fetchedData[fetchedData.length - 1].kabuuan_percent,styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}, lineWidth: {bottom: 3}, lineColor: BLUE}},
          ]
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 110,
          head: head,
          body: body,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.4, halign: "left", styles: {fontStyle: "bold"} }, // pinagkakakitaan
            1: { cellWidth: contentWidth * 0.1, halign: "center" }, // bilang ng lalaki
            2: { cellWidth: contentWidth * 0.1, halign: "center" }, // percent ng lalaki
            3: { cellWidth: contentWidth * 0.1, halign: "center" }, // bilang ng babae
            4: { cellWidth: contentWidth * 0.1, halign: "center" }, // percent ng babae
            5: { cellWidth: contentWidth * 0.1, halign: "center" }, // bilang ng kabuuan
            6: { cellWidth: contentWidth * 0.1, halign: "center" }, // percent ng kabuuan
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 4,
                right: 0,
                bottom: 0,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 3,
                right: 0,
                bottom: 7,
                left: 0,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 3,
                right: 0,
                bottom: 14,
                left: 0,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[10] Pinagkakakitaan ng Mamamayan ayon sa Uri ng Trabaho") {
        const title = "Table 11. Mga Pinagkakakitaan ng Mamamayan ayon sa Uri ng Trabaho";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding + 5,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 5, 85, { align: "left" });

        // headers
        const head = [
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {fontStyle: 'bolditalic', cellPadding: {left: 10, top: 10, bottom: 10}, halign: "left"}, colSpan: 7}],
          [
            {content: "Kalagayan ng Hanapbuhay"},
            {content: "Lalako", colSpan: 2},
            {content: "Babae", colSpan: 2},
            {content: "Kabuuan", colSpan: 2},
          ],
          [
            {content: ""}, 
            {content: "No."}, 
            {content: "%"}, 
            {content: "No."},
            {content: "%"},
            {content: "No."},
            {content: "%"},
          ],
        ]

        const generalData = [
          ...fetchedData[0].map((item) => (
            {
              status: item.class, 
              lalake_bilang: item.babae_bilang, 
              lalake_percent: item.babae_percentage, 
              babae_bilang: item.lalake_bilang, 
              babae_percent: item.lalake_percentage, 
              kabuuan_bilang: item.kabuuan_bilang, 
              kabuuan_percent: item.kabuuan_percentage
            }
          ))

        ];

        // const mainIncomeData = [
        //   ...fetchedData[1].map((item) => (
        //     {category: item.category, count: item.bilang, percent: item.percent}
        //   ))
        // ]

        // const otherIncomeData = fetchedData[1].length !== 0 ? fetchedData.map((item) => {
        //   return (
        //     {
        //       category: item.category, 
        //       count: item.bilang, 
        //       percent: item.percent
        //     }
        //   )
        // }) : []


        const body = [
          [{content: "Kalagayan ng Hanapbuhay", colSpan: 7, styles: {fontStyle: "bold", cellPadding: {left: 5, top: 10}}}],
          ...generalData.flatMap((item, index) => {
            const rows = [];
            const lastItem = index === generalData.length - 1;
            rows.push([
              {content: item.status, styles: {lineWidth: {bottom: lastItem ? 4 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold" : "normal", cellPadding: {left: 10, top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: item.lalake_bilang, styles: {lineWidth: {bottom: lastItem ? 4 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: item.lalake_percent, styles: {lineWidth: {bottom: lastItem ? 4 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: item.babae_bilang, styles: {lineWidth: {bottom: lastItem ? 4 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: item.babae_percent, styles: {lineWidth: {bottom: lastItem ? 4 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: item.kabuuan_bilang, styles: {lineWidth: {bottom: lastItem ? 4 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
              {content: item.kabuuan_percent, styles: {lineWidth: {bottom: lastItem ? 4 : 0}, lineColor: BLACK, fontStyle: lastItem ? "bold": "normal", cellPadding: {top: lastItem ? 15 : 5, bottom: lastItem ? 15 : 0}}},
            ]);

            if (item.subStatus) {
              for (const ss of item.subStatus) {
                rows.push(
                  [
                    {content: ss.status, styles: {cellPadding: {left: 20, top: 5}}},
                    {content: ss.lalake_bilang, styles: {cellPadding: {top: 5}}},
                    {content: ss.lalake_percent, styles: {cellPadding: {top: 5}}},
                    {content: ss.babae_bilang, styles: {cellPadding: {top: 5}}},
                    {content: ss.babae_percent, styles: {cellPadding: {top: 5}}},
                    {content: ss.kabuuan_bilang, styles: {cellPadding: {top: 5}}},
                    {content: ss.kabuuan_percent, styles: {cellPadding: {top: 5}}},
                  ]
                )
              }
            }

            return rows;
          }),

          // MAIN SOURCE OF INCOME
          // [
          //   {content: "MAIN SOURCE OF INCOME", colSpan: 5, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}}},
          //   {content: "No.", styles: {fontStyle: "bold",  cellPadding: {top: 20, bottom: 10}}},
          //   {content: "%", styles: {fontStyle: "bold",  cellPadding: {top: 20, bottom: 10}}}
          // ],
          // ...mainIncomeData.flatMap((item, index) => {
          //   const rows = [];
          //   const lastIndex = index === mainIncomeData.length - 1;
          //   rows.push([
          //     {
          //       content: item.category, 
          //       colSpan: 5, 
          //       styles: {
          //         fontStyle: lastIndex ? "bold" : "normal", 
          //         cellPadding: {left: lastIndex ? 75 : 10, top: lastIndex ? 10 : 3, bottom: lastIndex ? 10 : 3}
          //       }},
          //     {
          //       content: item.count, 
          //       styles: {
          //         fontStyle: lastIndex ? "bold" : "normal", 
          //         cellPadding: {top: lastIndex ? 15 : 3, bottom: lastIndex ? 15 : 3}
          //       }},
          //     {content: item.percent, styles: {cellPadding: {top: 3, bottom: 3}}},
          //   ])
          //   return rows;
          // }),
          // OTHER SOURCE OF INCOME
          // [
          //   {content: "Other Sources of Income", colSpan: 5, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}}},
          //   {content: "No.", styles: {fontStyle: "bold",  cellPadding: {top: 20, bottom: 10}}},
          //   {content: "%", styles: {fontStyle: "bold",  cellPadding: {top: 20, bottom: 10}}}
          // ],
          // ...otherIncomeData.flatMap((item, index) => {
          //   const rows = [];

          //   rows.push([
          //     {content: item.category, colSpan: 5, styles: {cellPadding: {left: 10, top: 3, bottom: 3}}},
          //     {content: item.count, styles: {cellPadding: {top: 3, bottom: 3}}},
          //     {content: item.percent, styles: {cellPadding: {top: 3, bottom: 3}}},
              
          //   ])
 
          //   return rows;
          // }),
          // [
          //   {content: "TOTAL: ", colSpan: 5, styles: {fontStyle: "bold", cellPadding: {left: 75, top: 10, bottom: 10}}},
          //   {content: fetchedData[fetchedData.length - 1].count, styles: {fontStyle: "bold", cellPadding: {top: 15, bottom: 15}}},
          // ]
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.4, halign: "left", styles: {fontStyle: "bold"} }, // edad
            1: { cellWidth: contentWidth * 0.1, halign: "center" }, // bilang ng lalaki
            2: { cellWidth: contentWidth * 0.1, halign: "center" }, // percent ng lalaki
            3: { cellWidth: contentWidth * 0.1, halign: "center" }, // bilang ng babae
            4: { cellWidth: contentWidth * 0.1, halign: "center" }, // percent ng babae
            5: { cellWidth: contentWidth * 0.1, halign: "right" }, // bilang ng kabuuan
            6: { cellWidth: contentWidth * 0.1, halign: "right" }, // percent ng kabuuan
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = BLACK;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 4,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 3,
                right: 0,
                bottom: 15,
                left: 0,
              };
            } else if (data.section === "head" && (data.row.index === 1 || data.row.index === 2)) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.cellPadding = {
                top: 5,
                right: 0,
                bottom: 5,
                left: 0,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[11a] Bansa, bilang at uri ng hanapbuhay ng mga OFW") {
        const title = "Table 11. Bilang at Uri ng Hanapbuhay ng mga Overseas Contract Workers";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding + 5,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 5, 85, { align: "left" });

        // headers
        const head = [
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5, styles: {fontStyle: 'bolditalic', cellPadding: {left: 10, top: 10, bottom: 10}, halign: "left"}}],
        ]

        const generalData = {
          title: "Number of OFW:",
          genders: [
            {gender: 'Male', count: fetchedData[0].filter(item => item.sex === 'Male')[0].bilang ? fetchedData[0].filter(item => item.sex === 'Male')[0].bilang : 0},
            {gender: 'Female', count:  fetchedData[0].filter(item => item.sex === 'Female')[0].bilang ? fetchedData[0].filter(item => item.sex === 'Female')[0].bilang : 0}
          ]
        };

        const typeOfWorks = [
          ...fetchedData[1].map((item) => ({
            work: item.trabaho, 
            count: item.bilang, 
            percent: item.percent
          }))
        ]

        const parseData = () => {
          const items = [];
          let prev_country = ''
          let works = [];
          for (let item of fetchedData[2].slice(0, fetchedData[2].length)) {
            if (prev_country === '') {
              prev_country = item.country;
              works.push({
                work: item.trabaho,
                count: item.bilang,
                percent: item.percent
              })
            } else if (item.country === prev_country) {
              works.push({
                work: item.trabaho,
                count: item.bilang,
                percent: item.percent
              })
            } else {
              items.push({
                country: prev_country,
                works: works
              });
              prev_country = item.country
              works = [
                {
                  work: item.trabaho,
                  count: item.bilang,
                  percent: item.percent
                }
              ]
            }
          }

          return items;
        }

        const worksByCountry = [
          ...parseData()
        ]

        const body = [
          // GENERAL DATA
          [{content: generalData.title, colSpan: 3, styles: {fontStyle: "bold", cellPadding: {left: 5, top: 10}}}],
          ...generalData.genders.map((item) => {
            return [
              "",
              {content: item.gender, styles: {halign: "left", fontStyle: "bold", cellPadding: {top: 5, bottom: 5}}},
              {content: item.count, styles: {halign: "left", cellPadding: {bottom: 5, top: 5}}}
            ]
          }),

          // TYPE OF WORK
          [
            {content: "Type of Work", colSpan: 3, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}}},
            {content: "No.", styles: {fontStyle: "bold",  cellPadding: {top: 20, bottom: 10}}},
            {content: "%", styles: {fontStyle: "bold",  cellPadding: {top: 20, bottom: 10}}}
          ],
          ...typeOfWorks.flatMap((item, index) => {
            const rows = [];
            const lastIndex = index === typeOfWorks.length - 1;
            rows.push([
              {content: item.work, colSpan: 3, styles: {fontStyle: lastIndex ? "bold" : "normal", cellPadding: {left: lastIndex ? 75 : 10, top: lastIndex ? 10 : 3, bottom: lastIndex ? 10 : 3}}},
              {content: item.count, styles: {fontStyle: lastIndex ? "bold" : "normal", cellPadding: {top: lastIndex ? 15 : 3, bottom: lastIndex ? 15 : 3}}},
              {content: item.percent, styles: {cellPadding: {top: 3, bottom: 3}}},
              
            ])
 
            return rows;
          }),
          

          // TYPE OF WORK BY COUNTRY
          [
            {content: "Type of Work by country", colSpan: 5, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}}},
          ],
          ...worksByCountry.flatMap((item, index) => {
            const rows = [];

            rows.push([
              {content: item.country, colSpan: 5, styles: {fontStyle: "bold", cellPadding: {left: 10, top: 3, bottom: 3}}},
            ])

            for (const workItem of item.works) {
              rows.push([
                {content: workItem.work, colSpan: 3, styles: {cellPadding: {left: 20}}},
                {content: workItem.count},
                {content: workItem.percent}
              ]);
            }
 
            return rows;
          }),
          [
            {content: "TOTAL: ", colSpan: 3, styles: {fontStyle: "bold", cellPadding: {left: 75, top: 10, bottom: 10}}},
            {content: fetchedData[2][fetchedData[2].length - 1].bilang, styles: {fontStyle: "bold", cellPadding: {top: 15, bottom: 15}}},
          ]
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.4, halign: "left", styles: {fontStyle: "bold"} }, // edad
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, 
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, 
            3: { cellWidth: contentWidth * 0.1, halign: "center" }, // bilang
            4: { cellWidth: contentWidth * 0.1, halign: "center" }, // percent
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = BLACK;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 4,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 3,
                right: 0,
                bottom: 15,
                left: 0,
              };
            } else if (data.section === "head" && (data.row.index === 1 || data.row.index === 2)) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.cellPadding = {
                top: 5,
                right: 0,
                bottom: 5,
                left: 0,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[11b] Bansa, bilang at uri ng hanapbuhay ng mga OFW ayon sa kasarian") {
        const title = "Table 11. Bilang at Uri ng Hanapbuhay ng mga Overseas Contract Workers by sex";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(
          title,
          padding + 5,
          70,
          { align: "left" }
        );

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding + 5, 85, { align: "left" });

        // headers
        const head = [
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5, styles: {fontStyle: 'bolditalic', cellPadding: {left: 10, top: 10, bottom: 10}, halign: "left"}}],
        ]

        const generalData = {
          title: "Number of OFW:",
          genders: [
            {gender: 'Male', count: fetchedData[0].filter(item => item.sex === 'Male')[0].bilang ? fetchedData[0].filter(item => item.sex === 'Male')[0].bilang : 0},
            {gender: 'Female', count:  fetchedData[0].filter(item => item.sex === 'Female')[0].bilang ? fetchedData[0].filter(item => item.sex === 'Female')[0].bilang : 0}
          ]
        };

        const parseTypeOfWorkData = () => {
          if (fetchedData[1].length === 0) return []
          const items = [];
          let prev_gender = ''
          let works = [];
          for (let item of fetchedData[1].slice(0, fetchedData[1].length)) {
            if (prev_gender === '') {
              prev_gender = item.sex;
              works.push({
                work: item.trabaho,
                count: item.bilang,
                percent: item.percent
              })
            } else if (item.sex === prev_gender) {
              works.push({
                work: item.trabaho,
                count: item.bilang,
                percent: item.percent
              })
            } else {
              items.push({
                gender: prev_gender,
                works: works
              });
              prev_gender = item.sex
              works = [
                {
                  work: item.trabaho,
                  count: item.bilang,
                  percent: item.percent
                }
              ]
            }
          }

          return items;
        }

        const typeOfWorks = [
          ...parseTypeOfWorkData()
        ]

        const parseWorksByCountryData = (gender, count) => {
          if (fetchedData[2].length === 0) return []; 
          const items = [];
          let prev_country = ''
          let works = [];
          for (let item of fetchedData[2].slice(0, fetchedData[2].length)) {
            if (item.sex === gender) {
              if (prev_country === '') {
                prev_country = item.country;
                works.push({
                  work: item.trabaho,
                  count: item.bilang,
                  percent: item.percent
                })
              } else if (item.country === prev_country) {
                works.push({
                  work: item.trabaho,
                  count: item.bilang,
                  percent: item.percent
                })
              } else {
                items.push({
                  country: prev_country,
                  works: works
                });
                prev_country = item.country
                works = [
                  {
                    work: item.trabaho,
                    count: item.bilang,
                    percent: item.percent
                  }
                ]
              }
            }
          }
          items.push({
            country: prev_country,
            works: works
          });

          return {gender: gender, count: count, works: items};
        }

        const worksByCountryBySex = [
          parseWorksByCountryData("Female", 
            fetchedData[2].reduce((sum, item) => {
              return sum + (item.sex === "Female" ? Number(item.bilang) : 0);
            }, 0)
          ),
          parseWorksByCountryData("Male", 
            fetchedData[2].reduce((sum, item) => {
              return sum + (item.sex === "Male" ? Number(item.bilang) : 0);
            }, 0)
          ),
        ]

        const body = [
          // GENERAL DATA
          [{content: generalData.title, colSpan: 3, styles: {fontStyle: "bold", cellPadding: {left: 5, top: 10}}}],
          ...generalData.genders.map((item) => {
            return [
              "",
              {content: item.gender, styles: {halign: "left", fontStyle: "bold", cellPadding: {top: 5, bottom: 5}}},
              {content: item.count, styles: {halign: "left", cellPadding: {bottom: 5, top: 5}}}
            ]
          }),

          // TYPE OF WORK BY SEX
          [
            {content: "Type of Work by sex", styles: {lineColor: BLACK, lineWidth: {top: 2}, fontStyle: "bold", cellPadding: {top: 10, bottom: 10}}, colSpan: 5}
          ],
          ...typeOfWorks.flatMap((item, index) => {
            const rows = [];

            rows.push([
              {content: item.gender, colSpan: 5, styles: {fontStyle: "bold", cellPadding: {left: 5, top: 3, bottom: 3}, fillColor: GRAY}},
            ]);

            item.works.forEach((workItem) => {
              rows.push([
                {content: workItem.work, colSpan: 3},
                {content: workItem.count},
                {content: workItem.percent}
              ])
            });
 
            return rows;
          }),
          [
            {content: "TOTAL: ", colSpan: 3, styles: {fontStyle: "bold", cellPadding: {left: 75, top: 10, bottom: 10}}},
            {content: fetchedData[1][fetchedData[1].length - 1].bilang, styles: {fontStyle: "bold", cellPadding: {top: 15, bottom: 15}}},
          ],

          // TYPE OF WORK BY COUNTRY BY SEX
          [
            {content: "Type of Work by country by sex", colSpan: 5, styles: {fontStyle: "bold", cellPadding: {top: 20, bottom: 10}}},
          ],
          ...worksByCountryBySex.flatMap((item, index) => {
            const rows = [];

            rows.push([
              {content: item.gender, colSpan: 3, styles: {fontStyle: "bold", cellPadding: {top: 3, bottom: 3}, fillColor: GRAY}},
              {content: item.count, styles: {fontStyle: "bold", cellPadding: {top: 3, bottom: 3}, fillColor: GRAY}},
              {content: "", styles: {fontStyle: "bold", cellPadding: {top: 3, bottom: 3}, fillColor: GRAY}},
            ])

            for (const workItem of item.works) {
              rows.push([
                {content: workItem.country, colSpan: 3, styles: {fontStyle: "bold"}},
              ]);

              workItem.works.forEach((work) => {
                rows.push([
                  {content: work.work, colSpan: 3, styles: {cellPadding: {left: 10}}},
                  {content: work.count},
                  {content: work.percent}
                ])
              })
            }
 
            return rows;
          }),
          [
            {content: "TOTAL both sexes: ", colSpan: 3, styles: {fontStyle: "bold", cellPadding: {left: 75, top: 10, bottom: 10}}},
            {content: fetchedData[2][fetchedData[2].length - 1].bilang, styles: {fontStyle: "bold", cellPadding: {top: 15, bottom: 15}}},
          ]
        ]

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY: 100,
          head: head,
          body: body,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.4, halign: "left", styles: {fontStyle: "bold"} }, // edad
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, 
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, 
            3: { cellWidth: contentWidth * 0.1, halign: "right" }, // bilang
            4: { cellWidth: contentWidth * 0.1, halign: "right" }, // percent
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.lineColor = BLUE;
              data.cell.styles.lineWidth = {
                top: 0,
                right: 0,
                bottom: 4,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 3,
                right: 0,
                bottom: 15,
                left: 0,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(padding, pageHeight - padding - 10, pageWidth - padding, pageHeight - padding - 10);
          }
        });
      } else if (formName === "[12] Kita kada buwan ng bawat pamilya") {
        const title = "Table 11. Kita kada buwan ng Pamilya ng Barangay";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(title, padding, 70, { align: "left" });

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const head = [
          ["Income", "No.", "%"], 
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5, styles: {fontStyle: 'bolditalic', cellPadding: {left: 10, top: 10, bottom: 10}, halign: "left"}}],
        ];

        const incomeData = [
          ...fetchedData[0].map((item, index) => ({range: item.income_range, count: item.bilang, percent: item.percent}))
        ]

        const povertyIncidence = [
          ...fetchedData[2].map((item, index) => ({desc: item.poverty_incidence, count: item.family_count, percent: item.percent}))
        ]

        const sampleBody = [
          ...incomeData.map((item, index) => {
            const lastItem = index === incomeData.length - 1;
            return [
              {content: item.range, styles: {halign: "right", fontStyle: "bold", cellPadding: {right: 50, bottom: lastItem ? 15 : 10}}},
              {content: item.count, styles: {halign: "center", fontStyle: lastItem ? "bold" : "normal", cellPadding: {bottom: lastItem ? 15 : 10}}},
              {content: item.percent, styles: {halign: "center", fontStyle: lastItem ? "bold" : "normal", cellPadding: {bottom: lastItem ? 15 : 10}}}
            ]
          }),
          [
            {content: "Average family monthly income: ", styles: {fontStyle: "bold"}},
            {content: fetchedData[1][0].average_monthly_income, styles: {fontStyle: "bold"}},
            
          ],
          [
            {content: "Average annual per capita income: ", styles: {fontStyle: "bold"}},
            {content: fetchedData[1][0].average_anual_income, styles: {fontStyle: "bold"}},
          ],
          [
            {content: "Poverty incidence", styles: {fontStyle: "bold", cellPadding: {top: 15}}}
          ],
          ...povertyIncidence.map((item, index) => {
            const lastItem = index === povertyIncidence.length - 1;
            return (
              [
                {content: item.desc, styles: {halign: lastItem ? "center" : "left", fontStyle: lastItem ? "bold" : "normal", cellPadding: {left: 20, top: 5, bottom: 5}}},
                {content: item.count, styles: {fontStyle: lastItem ? "bold" : "normal"}},
                {content: item.percent, styles: {fontStyle: lastItem ? "bold" : "normal"}}
              ]
            )
          }),
          [{content: "*http://www.ns.cb.gov.ph/poverty/2009/table_3.asp", styles: {fontSize: 8, cellPadding: {top: 40}}}],
          [{content: "**http://www.ns.cb.gov.ph/poverty/portal_/", styles: {fontSize: 8}}]
        ]
          
        const contentWidth = pageWidth - padding * 2;

        // GENERAL INFO TABLE
        autoTable(doc, {
          startY: 110,
          head: head,
          body: sampleBody,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2,
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.5, halign: "left" }, // Income
            1: { cellWidth: contentWidth * 0.25, halign: "right" }, // Bilang
            2: { cellWidth: contentWidth * 0.25, halign: "right" }, // Percent
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 6,
                left: 0,
              };
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(
              padding,
              pageHeight - padding - 10,
              pageWidth - padding,
              pageHeight - padding - 10
            );
          },
        });


      } else if (formName === "[13] Kalagayan ng Barangay ayon sa Uri at Kaanyuan ng Bahay") {
        const title = "Table 12. Kalagayan ng Barangay ayon sa Uri at Kaanyuan ng Bahay";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(title, padding, 70, { align: "left" });

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const head = [
          ["Uri", "Bilang", "%"], 
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5, styles: {fontStyle: 'bolditalic', cellPadding: {left: 10, top: 10, bottom: 10}, halign: "left"}}],
        ];

        const data = [
          {title: "Pagmamay-ari sa Bahay:", status: fetchedData[0].map((item) => (
            {name: item.value_name, count: item.bilang, percent: item.percent}
          ))},
          {title: "Pagmamay-ari sa Lupa:", status: fetchedData[1].map((item) => (
            {name: item.value_name, count: item.bilang, percent: item.percent}
          ))},
          {title: "Uwi ng materyales ng Haligi ng Bahay:", status: fetchedData[2].map((item) => (
            {name: item.value_name, count: item.bilang, percent: item.percent}
          ))},
          {title: "Kaanyuan ng Bahay:", status: fetchedData[3].map((item) => (
            {name: item.value_name, count: item.bilang, percent: item.percent}
          ))},
          {title: "Pinagkukunan ng Enerhiya", status: fetchedData[4].map((item) => (
            {name: item.value_name, count: item.bilang, percent: item.percent}
          ))},
          // {title: "Uri ng Pailaw na Ginagamit:", status: [
          //   {name: "Solar Power", count: 30, percent: 10},
          //   {name: "Kerosene (Gaas)", count: 15, percent: 5},
          //   {name: "Generator", count: 20, percent: 6.67},
          //   {name: "Own Electric Meter", count: 200, percent: 66.67},
          //   {name: "Shared Electric Meter", count: 35, percent: 11.66},
          //   {name: "Kabuuan", count: 300, percent: 100},
          // ]},
          {title: "Gamit sa Pagluluto:", status: fetchedData[6].map((item) => (
            {name: item.value_name, count: item.bilang, percent: item.percent}
          ))},
          {title: "Materyales ng Sahig:", status: fetchedData[7].map((item) => (
            {name: item.value_name, count: item.bilang, percent: item.percent}
          ))},
          {title: "Materyales ng Bubong:", status: fetchedData[8].map((item) => (
            {name: item.value_name, count: item.bilang, percent: item.percent}
          ))},
        ]

        const parsedEcologicalData = fetchedData[9].slice(0, fetchedData[9].length - 1)
          .reduce((acc, item, index, arr) => {
            if (acc.prev_eco === '') {
              acc.prev_eco = item.ecological_name;
              acc.locations.push({
                name: item.house_location_name,
                count: item.bilang,
                percent: item.percent
              });
              return acc;
            }

            if (item.ecological_name === acc.prev_eco) {
              acc.locations.push({
                name: item.house_location_name,
                count: item.bilang,
                percent: item.percent
              });
            } else {
              acc.items.push({
                terrain: acc.prev_eco,
                distances: acc.locations
              });

              acc.prev_eco = item.ecological_name;
              acc.locations = [
                {
                  name: item.house_location_name,
                  count: item.bilang,
                  percent: item.percent
                }
              ];
            }

            if (index === arr.length - 1) {
              acc.items.push({
                terrain: acc.prev_eco,
                distances: acc.locations
              });
            }

            return acc;
        }, { items: [], prev_eco: '', locations: [] }).items;

        const locationData = {
          title: "Lokasyon ng Pinagtatayuan ng Bahay:", 
          terrains: [
            ...parsedEcologicalData,
          ],
          summary: {name: "Kabuuan", count: fetchedData[9][fetchedData[9].length - 1].bilang, percent: fetchedData[9][fetchedData[9].length - 1].percent},
        }

        const body = [
          ...data.flatMap((item) => {
            const rows = [];

            rows.push([
              {content: item.title, colSpan: 3, styles: {fontStyle: "bold", cellPadding: {left: 10, top: 10, bottom: 5}}}
            ]);

            item.status.forEach((sta, index) => {
              const lastItem = index === item.status.length - 1;
              rows.push([
                {content: sta.name, styles: {fontStyle: lastItem ? "bolditalic" : "normal", cellPadding: {left: 10, bottom: lastItem ? 15 : 5}, lineColor: GRAY, lineWidth: {bottom: lastItem ? 6 : 0}}},
                {content: sta.count, styles: {fontStyle: lastItem ? "bold" : "normal", cellPadding: {bottom: lastItem ? 15 : 5}, lineColor: GRAY, lineWidth: {bottom: lastItem ? 6 : 0}}},
                {content: sta.percent, styles: {fontStyle: lastItem ? "bold" : "normal", cellPadding: {bottom: lastItem ? 15 : 5}, lineColor: GRAY, lineWidth: {bottom: lastItem ? 6 : 0}}},
              ])
            })

            return rows;
          }),
          [{content: locationData.title, colSpan: 3, styles: {fontStyle: "bold"}}],
          ...locationData.terrains.flatMap((item) => {
            const rows = [];

            rows.push([
              {content: item.terrain, styles: {fontStyle: "bold"}, colSpan: 3}
            ]);

            item.distances.forEach((distance, index) => {
              rows.push([
                {content: distance.name, styles: {cellPadding: {left: 15}}},
                {content: distance.count},
                {content: distance.percent}
              ])
            })

            return rows;
          }),
          [
            {content: locationData.summary.name, styles: {fontStyle: "bolditalic", lineColor: GRAY, lineWidth: {bottom: 1.5}, cellPadding: {bottom: 20}}},
            {content: locationData.summary.count, styles: {fontStyle: "bold", lineColor: GRAY, lineWidth: {bottom: 1.5}, cellPadding: {bottom: 20}}},
            {content: locationData.summary.percent, styles: {fontStyle: "bold", lineColor: GRAY, lineWidth: {bottom: 1.5}, cellPadding: {bottom: 20}}},
          ]
        ]
          
        const contentWidth = pageWidth - padding * 2;

        autoTable(doc, {
          startY: 110,
          head: head,
          body: body,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2,
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.5, halign: "left" }, // Income
            1: { cellWidth: contentWidth * 0.25, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.25, halign: "center" }, // Percent
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 6,
                left: 0,
              };
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(
              padding,
              pageHeight - padding - 10,
              pageWidth - padding,
              pageHeight - padding - 10
            );
          },
        });


      } else if (formName === "[14] Bilang ng pamilya na mayroong sasakyan, appliances, telepono at internet") {
        const title = "Table 13. Bilang ng pamilya ayon sa bilang na sasakyan, appliances, telepono \nat internet.";
        const dateToday = new Date();
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(title, padding, 70, { align: "left" });

        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 95, { align: "left" });

        const head = [
          ["Uri", "Bilang", "%"], 
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, colSpan: 5, styles: {fontStyle: 'bolditalic', cellPadding: {left: 5, top: 10, bottom: 10}, halign: "left"}}],
        ];

        const contentWidth = pageWidth - padding * 2;

        const vehicleData = [
          ...fetchedData[0].slice(0).map((item, index) => (
            {vehicle: item.asset_name, count: item.total, percent: item.percent}
          ))
        ]

        const vehicleBody = [
          [
            {content: "Type of vehicles", styles: {cellPadding: {left: 10, top: 20, bottom: 10}, fontStyle: "bold"}}
          ],
          ...vehicleData.map((sta, index) => {
            const lastItem = index === vehicleData.length - 1
            return [
              {content: sta.vehicle, styles: {fontStyle: lastItem ? "boldItalic" : "normal", cellPadding: lastItem ? {top: 15, left: 15} : {left: 15, bottom: 5}}},
              {content: sta.count, styles: {fontStyle: lastItem ? "bold" : "normal", cellPadding: lastItem ? {top: 15} : {bottom:  5}}},
              {content: sta.percent, styles: {fontStyle: lastItem ? "bold" : "normal", cellPadding: lastItem ? {top: 15} : {bottom:  5}}},
            ]
          })
        ]

        // VEHICLE TABLE
        autoTable(doc, {
          startY: 110,
          head: head,
          body: vehicleBody,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2,
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.5, halign: "left" }, // Income
            1: { cellWidth: contentWidth * 0.25, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.25, halign: "center" }, // Percent
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 6,
                left: 0,
              };
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(
              padding,
              pageHeight - padding - 10,
              pageWidth - padding,
              pageHeight - padding - 10
            );
          },
        });

        doc.addPage();

        const appliancesData = [
          ...fetchedData[1].slice(0).map((item, index) => (
            {appliance: item.asset_name, count: item.total, percent: item.percent}
          ))
        ]

        const appliancesBody = [
          [
            {content: "Type of appliances", styles: {cellPadding: {left: 10, top: 20, bottom: 10}, fontStyle: "bold"}}
          ],
          ...appliancesData.map((sta, index) => {
            const lastItem = index === appliancesData.length - 1;
            return [
              {content: sta.appliance.replace(/^\t+/, ""), styles: {fontStyle: lastItem ? 'bolditalic' : 'normal', cellPadding: lastItem ? {top: 15, left: 15} : {left: 15, bottom:  5}}},
              {content: sta.count, styles: {fontStyle: lastItem ? 'bold' : 'normal', cellPadding: lastItem ? {top: 15} : {bottom:  5}}},
              {content: sta.percent, styles: {fontStyle: lastItem ? 'bold' : 'normal', cellPadding: lastItem ? {top: 15} : {bottom:  5}}},
            ]
          })
        ]

        // APPLIANCES TABLE
        autoTable(doc, {
          startY: padding,
          head: head,
          body: appliancesBody,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2,
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.5, halign: "left" }, // Income
            1: { cellWidth: contentWidth * 0.25, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.25, halign: "center" }, // Percent
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 6,
                left: 0,
              };
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(
              padding,
              pageHeight - padding - 10,
              pageWidth - padding,
              pageHeight - padding - 10
            );
          },
        });

        doc.addPage();

        const telephoneData = [
          ...fetchedData[2].slice(0, fetchedData[2].length - 1).map((item, index) => (
            {name: item.provider, count: item.bilang, percent: item.percent}
          ))
        ]

        const internetData = [
          ...fetchedData[3].slice(0, fetchedData[3].length - 1).map((item, index) => (
            {name: item.internet, count: item.total, percent: item.percent}
          ))
        ]

        const telephoneAndInternetBody = [

          // TELEPHONE BODY
          [
            {content: "Telephone Service Providers", styles: {cellPadding: {left: 10, top: 20, bottom: 10}, fontStyle: "bold"}}
          ],
          ...telephoneData.map((sta) => [
              {content: sta.name, styles: { cellPadding: {left: 15, bottom:  5}}},
              {content: sta.count, styles: { cellPadding: {bottom:  5}}},
              {content: sta.percent, styles: { cellPadding: {bottom:  5}}},
            ]
          ),
          fetchedData[2].length !== 1 ? [
            {content: "Kabuuan", styles: {fontStyle: "bolditalic", cellPadding: {top: 15, left: 15}}},
            {content: fetchedData[2][fetchedData[2].length - 1].bilang, styles: {fontStyle: "bold", cellPadding: {top: 15}}},
            {content: 100.0, styles: {fontStyle: "bold", cellPadding: {top: 15}}},
          ] : [],

          // INTERNET BODY
          [
            {content: "Internet Service Providers", styles: {cellPadding: {left: 10, top: 20, bottom: 10}, fontStyle: "bold"}}
          ],
          ...internetData.map((sta) => [
              {content: sta.name, styles: { cellPadding: {left: 15, bottom:  5}}},
              {content: sta.count, styles: { cellPadding: {bottom:  5}}},
              {content: sta.percent, styles: { cellPadding: {bottom:  5}}},
            ]
          ),
          fetchedData[3].length !== 1 ? [
            {content: "Kabuuan", styles: {fontStyle: "bolditalic", cellPadding: {top: 15, left: 15, bottom: 20}, lineColor: GRAY, lineWidth: {bottom: 3}}},
            {content: fetchedData[3][fetchedData[3].length - 1].total, styles: {fontStyle: "bold", cellPadding: {top: 15, bottom: 20}, lineColor: GRAY, lineWidth: {bottom: 3}}},
            {content: fetchedData[3][fetchedData[3].length - 1].percent, styles: {fontStyle: "bold", cellPadding: {top: 15, bottom: 20}, lineColor: GRAY, lineWidth: {bottom: 3}}},
          ] : [],
        ]

        // TELEPHONE AND INTERNET TABLE
        autoTable(doc, {
          startY: padding,
          head: head,
          body: telephoneAndInternetBody,
          theme: "grid",
          showHead: "firstPage",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 0,
              top: 2,
              bottom: 2,
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10,
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.5, halign: "left" }, // Income
            1: { cellWidth: contentWidth * 0.25, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.25, halign: "center" }, // Percent
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 6,
                left: 0,
              };
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          },
          didDrawPage: function (data) {
            doc.setLineWidth(3);
            doc.setDrawColor(211, 211, 211);
            doc.line(
              padding,
              pageHeight - padding - 10,
              pageWidth - padding,
              pageHeight - padding - 10
            );
          },
        });
      }
    } else if (reportType === "Peace and Order Profile") {
      if (formName === "[1] Krimen na naranasan") {
        doc.setFontSize(12);
        doc.setFont(undefined, "bold"); 
        doc.text(
          "Table . Mga krimen na naranasan ng pamilya",
          padding,
          70,
          { align: "left" }
        );

        const dateToday = new Date();
        const formattedDate = formatDateToDDMMMYY(dateToday);
        doc.setFontSize(10);
        doc.setFont(undefined, "italic");
        doc.text(formattedDate, padding, 85, { align: "left" });

        const mainHead = [
            "Uri",
            "Bilang",
            "%"
        ];

        const head = [
          mainHead,
          [{content: `${
            barangayName ? `Barangay: ${barangayName}, ${municipalName}, ${provinceName}` :
            municipalName ? `Municipality: ${municipalName}, ${provinceName}` :
            `Province: ${provinceName}`
          }`, styles: {halign: "left"}}]
        ];

        const sampleBody = [
          [
            {content: "Mga uri ng krimen na naranasan", styles: {fontStyle: "bold"}},
          ],
          ...(fetchedData.length !== 1 ? fetchedData.slice(0, fetchedData.length - 1).map((item) => {
            return ([
              {content: item.threat},
              {content: item.bilang},
              {content: item.percent}
            ])
          }): []),
          [
            {content: 'Kabuuan', styles: {fontStyle: 'bold'}},
            {content: fetchedData[fetchedData.length - 1].bilang, styles: {fontStyle: 'bold'}},
            {content: fetchedData[fetchedData.length - 1].percent, styles: {fontStyle: 'bold'}},
          ]
        ];

        const contentWidth = pageWidth - (padding * 2);

        autoTable(doc, {
          startY:100,
          head: head,
          body: sampleBody.length !== 0 ?  sampleBody : [Array(mainHead.length).fill("")],
          theme: "grid",
          margin: {
            left: padding,
            right: pageWidth - padding,
            bottom: padding + 20,
          },
          styles: {
            fontSize: 10,
            cellPadding: {
              left: 10,
              top: 3,
              bottom: 3
            },
            overflow: "linebreak",
            lineWidth: 0,
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            valign: "center",
            lineColor: [0, 0, 0],
            fontSize: 10, 
          },
          columnStyles: {
            0: { cellWidth: contentWidth * 0.6, halign: "left" }, // Kalagayan
            1: { cellWidth: contentWidth * 0.2, halign: "center" }, // Bilang
            2: { cellWidth: contentWidth * 0.2, halign: "center" }, // %
          },
          didParseCell: function (data) {
            if (data.section === "head" && data.row.index === 0) {
              data.cell.styles.lineColor = GRAY;
              data.cell.styles.lineWidth = {
                top: 3,
                right: 0,
                bottom: 8,
                left: 0
              }
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            } else if (data.section === "head" && data.row.index === 1) {
              data.cell.styles.cellPadding = {
                top: 0,
                right: 4,
                bottom: 10,
                left: 8,
              };
            }
          }
        });
      }
    }

    // Page Numbering
    doc.setFontSize(8);
    doc.setFont("times", "bolditalic");
    doc.setTextColor(0, 0, 125);
    const pageCount = doc.internal.getNumberOfPages();
    const currentDate = getCurrentDate();

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);

      const text = `Page ${i} of ${pageCount}`;
      const textWidth = doc.getTextWidth(text);

      doc.text(text, pageWidth - textWidth - padding, pageHeight - padding, {align: "left"});
      doc.text(currentDate, padding, pageHeight - padding, {align: "left"});
    }

    return doc;
  }

  const handleViewDownload = async (reportType, selectedForm, actionType) => {
    if (!isSearchApplied) {
      alert('Please click "Apply Search" first to enable table actions.');
      return;
    }
    if (!selectedForm) {
      alert(`Please select a form for ${reportType} before ${actionType}.`);
      return;
    }

    // locationData is already available from props
    const doc = await generateForm(reportType, selectedForm, locationData);
    const { provinceName, municipalName, barangayName } = locationData; // Redundant destructuring but harmless

    if (actionType === "view") {
      doc.output("dataurlnewwindow");
    } else if (actionType === "download") {
      const filename = `${barangayName}_${municipalName}_${provinceName}`;
      doc.save(
        `${selectedForm.replace(/\s+/g, "_")}_${filename.replace(
          /\s+/g,
          "_"
        )}.pdf`
      );
    }
  };

  const reportCategories = [
    { name: 'Agriculture and Fishery Profile', state: selectedAgricultureForm, setter: setSelectedAgricultureForm },
    { name: 'Disaster Risk Reduction Profile', state: selectedDisasterForm, setter: setSelectedDisasterForm },
    { name: 'Environmental Sanitation, Health and Nutrition Profile', state: selectedEnvironmentalForm, setter: setSelectedEnvironmentalForm },
    { name: 'Institutional Household, Death, and Migration Profile', state: selectedInstitutionalForm, setter: setSelectedInstitutionalForm },
    { name: 'Socio-economic Profile', state: selectedSocioEconomicForm, setter: setSelectedSocioEconomicForm },
    { name: 'Peace and Order Profile', state: selectedPeaceOrderForm, setter: setSelectedPeaceOrderForm },
  ];

  const disabledButtonStyles = {
    backgroundColor: '#cccccc',
    cursor: 'not-allowed',
    color: '#666666'
  };

  return (
    <div style={pageContainer}>
      {/* Removed local search input and apply search button */}
      <div style={reportContainer}>
        <h2 style={heading}>Generate Tables</h2>
        
        <div style={reportCardsContainer}>
          {reportCategories.map((category, index) => (
            <div key={index} style={card}>
              <h3>{category.name}</h3>
              <div style={{ marginBottom: '15px' }}>
                <label htmlFor={`select-form-${index}`} style={{ marginRight: '10px', fontSize: '16px' }}>Select Form:</label>
                <select
                  id={`select-form-${index}`}
                  value={category.state}
                  onChange={(e) => category.setter(e.target.value)}
                  style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc', width: '150px' }}
                  disabled={!isSearchApplied} // Disable dropdown if search not applied
                >
                  <option value="">-- Select --</option>
                  {formOptions[category.name] && formOptions[category.name].map((option, idx) => (
                    <option key={idx} value={option}>{option}</option>
                  ))}
                </select>
              </div>
              <button
                onClick={() => handleViewDownload(category.name, category.state, 'view')}
                style={{
                  ...button,
                  marginRight: "10px",
                  ...(!isSearchApplied || !category.state ? disabledButtonStyles : {})
                }}
                disabled={!isSearchApplied || !category.state}
              >
                View
              </button>
              <button
                onClick={() => handleViewDownload(category.name, category.state, 'download')}
                style={{
                  ...button,
                  ...(!isSearchApplied || !category.state ? disabledButtonStyles : {})
                }}
                disabled={!isSearchApplied || !category.state}
              >
                Download
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// Styling (reused from MultiReportPage for consistency)
const pageContainer = {
  // Removed marginTop as Header is now in parent
  minHeight: "calc(100vh - 0px)", // Adjusted minHeight
  backgroundColor: "#f8f9fa",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%", // Ensure it takes full width of parent
};

const reportContainer = {
  width: "100%", // Adjusted to fill parent's width
  backgroundColor: "#ffffff",
  padding: "30px",
  borderRadius: "10px",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
};

const heading = {
  fontSize: "24px",
  fontWeight: "bold",
  marginBottom: "20px",
  textAlign: "center",
  color: "#333",
};

const reportCardsContainer = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: "20px",
};

const card = {
  marginBottom: "20px",
  padding: "15px",
  border: "1px solid #ddd",
  borderRadius: "8px",
  backgroundColor: "#fefefe",
  boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
  flex: "1 1 calc(33% - 40px)", // Adjusted for 3 cards per row on larger screens
  minWidth: "280px",
  maxWidth: "calc(33% - 20px)", // Adjusted for 3 cards per row on larger screens
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
};

const button = {
  padding: "10px 20px",
  backgroundColor: "#007bff",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px",
  transition: 'background-color 0.3s ease',
};

const disabledButtonStyles = {
  backgroundColor: '#cccccc',
  cursor: 'not-allowed',
  color: '#666666',
};

export default Tables;